import { IconOption } from '@sistemiv/s-components/dist/esm/components/icon-picker/IconPicker'

export const initIcons: IconOption[] = [
  {
    id: 'building-id',
    name: 'building',
    base64string:
      'PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAzMCAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0Ljk5OTcgNS45MTY2N1YwLjI1SDAuODMzMDA4VjI1Ljc1SDI5LjE2NjNWNS45MTY2N0gxNC45OTk3Wk02LjQ5OTY3IDIyLjkxNjdIMy42NjYzNFYyMC4wODMzSDYuNDk5NjdWMjIuOTE2N1pNNi40OTk2NyAxNy4yNUgzLjY2NjM0VjE0LjQxNjdINi40OTk2N1YxNy4yNVpNNi40OTk2NyAxMS41ODMzSDMuNjY2MzRWOC43NUg2LjQ5OTY3VjExLjU4MzNaTTYuNDk5NjcgNS45MTY2N0gzLjY2NjM0VjMuMDgzMzNINi40OTk2N1Y1LjkxNjY3Wk0xMi4xNjYzIDIyLjkxNjdIOS4zMzMwMVYyMC4wODMzSDEyLjE2NjNWMjIuOTE2N1pNMTIuMTY2MyAxNy4yNUg5LjMzMzAxVjE0LjQxNjdIMTIuMTY2M1YxNy4yNVpNMTIuMTY2MyAxMS41ODMzSDkuMzMzMDFWOC43NUgxMi4xNjYzVjExLjU4MzNaTTEyLjE2NjMgNS45MTY2N0g5LjMzMzAxVjMuMDgzMzNIMTIuMTY2M1Y1LjkxNjY3Wk0yNi4zMzMgMjIuOTE2N0gxNC45OTk3VjIwLjA4MzNIMTcuODMzVjE3LjI1SDE0Ljk5OTdWMTQuNDE2N0gxNy44MzNWMTEuNTgzM0gxNC45OTk3VjguNzVIMjYuMzMzVjIyLjkxNjdaTTIzLjQ5OTcgMTEuNTgzM0gyMC42NjYzVjE0LjQxNjdIMjMuNDk5N1YxMS41ODMzWk0yMy40OTk3IDE3LjI1SDIwLjY2NjNWMjAuMDgzM0gyMy40OTk3VjE3LjI1WiIgZmlsbD0iIzRCNTI2QyIvPgo8L3N2Zz4K',
  },
  {
    id: 'briefcase-id',
    name: 'briefcase',
    base64string:
      'PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAzMCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjMzMzMgNi40OTk5MkgyMi4wODMzVjMuNjY2NTlDMjIuMDgzMyAyLjA5NDA5IDIwLjgyMjUgMC44MzMyNTIgMTkuMjUgMC44MzMyNTJIMTAuNzVDOS4xNzc0OCAwLjgzMzI1MiA3LjkxNjY1IDIuMDk0MDkgNy45MTY2NSAzLjY2NjU5VjYuNDk5OTJIMy42NjY2NUMyLjA5NDE1IDYuNDk5OTIgMC44MzMzMTMgNy43NjA3NSAwLjgzMzMxMyA5LjMzMzI1VjI0LjkxNjZDMC44MzMzMTMgMjYuNDg5MSAyLjA5NDE1IDI3Ljc0OTkgMy42NjY2NSAyNy43NDk5SDI2LjMzMzNDMjcuOTA1OCAyNy43NDk5IDI5LjE2NjYgMjYuNDg5MSAyOS4xNjY2IDI0LjkxNjZWOS4zMzMyNUMyOS4xNjY2IDcuNzYwNzUgMjcuOTA1OCA2LjQ5OTkyIDI2LjMzMzMgNi40OTk5MlpNMTAuNzUgMy42NjY1OUgxOS4yNVY2LjQ5OTkySDEwLjc1VjMuNjY2NTlaTTI2LjMzMzMgMjQuOTE2NkgzLjY2NjY1VjIyLjA4MzNIMjYuMzMzM1YyNC45MTY2Wk0yNi4zMzMzIDE3LjgzMzNIMy42NjY2NVY5LjMzMzI1SDcuOTE2NjVWMTIuMTY2NkgxMC43NVY5LjMzMzI1SDE5LjI1VjEyLjE2NjZIMjIuMDgzM1Y5LjMzMzI1SDI2LjMzMzNWMTcuODMzM1oiIGZpbGw9IiM0QjUyNkMiLz4KPC9zdmc+Cg==',
  },
  {
    id: 'train-id',
    name: 'train',
    base64string:
      'PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyNCAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDAuNDE2NzQ4QzUuNzM4MzIgMC40MTY3NDggMC42NjY2NTYgMS4xMjUwOCAwLjY2NjY1NiA2LjA4MzQyVjIwLjk1ODRDMC42NjY2NTYgMjMuNjkyNiAyLjg5MDgyIDI1LjkxNjcgNS42MjQ5OSAyNS45MTY3TDMuNDk5OTkgMjguMDQxN1YyOC43NTAxSDIwLjVWMjguMDQxN0wxOC4zNzUgMjUuOTE2N0MyMS4xMDkyIDI1LjkxNjcgMjMuMzMzMyAyMy42OTI2IDIzLjMzMzMgMjAuOTU4NFY2LjA4MzQyQzIzLjMzMzMgMS4xMjUwOCAxOC4yNjE3IDAuNDE2NzQ4IDEyIDAuNDE2NzQ4Wk0xMiAzLjI1MDA4QzIwLjUgMy4yNTAwOCAyMC41IDQuOTUwMDggMjAuNSA2LjA4MzQySDMuNDk5OTlDMy40OTk5OSA0Ljk1MDA4IDMuNDk5OTkgMy4yNTAwOCAxMiAzLjI1MDA4Wk0yMC41IDguOTE2NzVWMTMuMTY2N0gzLjQ5OTk5VjguOTE2NzVIMjAuNVpNMTguMzc1IDIzLjA4MzRINS42MjQ5OUM0LjQ0OTE2IDIzLjA4MzQgMy40OTk5OSAyMi4xMzQyIDMuNDk5OTkgMjAuOTU4NFYxNi4wMDAxSDIwLjVWMjAuOTU4NEMyMC41IDIyLjEzNDIgMTkuNTUwOCAyMy4wODM0IDE4LjM3NSAyMy4wODM0Wk0xMiAxNi43MDg0QzEwLjQ0MTcgMTYuNzA4NCA5LjE2NjY2IDE3Ljk4MzQgOS4xNjY2NiAxOS41NDE3QzkuMTY2NjYgMjEuMTAwMSAxMC40NDE3IDIyLjM3NTEgMTIgMjIuMzc1MUMxMy41NTgzIDIyLjM3NTEgMTQuODMzMyAyMS4xMDAxIDE0LjgzMzMgMTkuNTQxN0MxNC44MzMzIDE3Ljk4MzQgMTMuNTU4MyAxNi43MDg0IDEyIDE2LjcwODRaIiBmaWxsPSIjNEI1MjZDIi8+Cjwvc3ZnPgo=',
  },
  {
    id: 'gear-id',
    name: 'gear',
    base64string:
      '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',
  },
  {
    id: 'shoping-cart-id',
    name: 'shoping cart',
    base64string:
      'PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAyOSAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjAyOTIgMTYuNDE2NkMyMi4wOTE3IDE2LjQxNjYgMjMuMDI2NyAxNS44MzU4IDIzLjUwODQgMTQuOTU3NEwyOC41OCA1Ljc2MzI1QzI5LjEwNDIgNC44MjgyNSAyOC40MjQyIDMuNjY2NTkgMjcuMzQ3NSAzLjY2NjU5SDYuMzgwODVMNS4wNDkxOSAwLjgzMzI1MkgwLjQxNjY4N1YzLjY2NjU5SDMuMjUwMDJMOC4zNTAwMiAxNC40MTkxTDYuNDM3NTIgMTcuODc1OEM1LjQwMzM1IDE5Ljc3NDEgNi43NjMzNSAyMi4wODMzIDguOTE2NjkgMjIuMDgzM0gyNS45MTY3VjE5LjI0OTlIOC45MTY2OUwxMC40NzUgMTYuNDE2NkgyMS4wMjkyWk03LjcyNjY5IDYuNDk5OTJIMjQuOTM5MkwyMS4wMjkyIDEzLjU4MzNIMTEuMDg0Mkw3LjcyNjY5IDYuNDk5OTJaTTguOTE2NjkgMjMuNDk5OUM3LjM1ODM1IDIzLjQ5OTkgNi4wOTc1MiAyNC43NzQ5IDYuMDk3NTIgMjYuMzMzM0M2LjA5NzUyIDI3Ljg5MTYgNy4zNTgzNSAyOS4xNjY2IDguOTE2NjkgMjkuMTY2NkMxMC40NzUgMjkuMTY2NiAxMS43NSAyNy44OTE2IDExLjc1IDI2LjMzMzNDMTEuNzUgMjQuNzc0OSAxMC40NzUgMjMuNDk5OSA4LjkxNjY5IDIzLjQ5OTlaTTIzLjA4MzQgMjMuNDk5OUMyMS41MjUgMjMuNDk5OSAyMC4yNjQyIDI0Ljc3NDkgMjAuMjY0MiAyNi4zMzMzQzIwLjI2NDIgMjcuODkxNiAyMS41MjUgMjkuMTY2NiAyMy4wODM0IDI5LjE2NjZDMjQuNjQxNyAyOS4xNjY2IDI1LjkxNjcgMjcuODkxNiAyNS45MTY3IDI2LjMzMzNDMjUuOTE2NyAyNC43NzQ5IDI0LjY0MTcgMjMuNDk5OSAyMy4wODM0IDIzLjQ5OTlaIiBmaWxsPSIjNEI1MjZDIi8+Cjwvc3ZnPgo=',
  },
  {
    id: 'city-id',
    name: 'city',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyNiAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjI1IDEzLjU4MzNWNS4wODMyNUwxMyAwLjgzMzI1Mkw4Ljc1IDUuMDgzMjVWNy45MTY1OEgwLjI1VjI3Ljc0OTlIMjUuNzVWMTMuNTgzM0gxNy4yNVpNNS45MTY2NyAyNC45MTY2SDMuMDgzMzNWMjIuMDgzM0g1LjkxNjY3VjI0LjkxNjZaTTUuOTE2NjcgMTkuMjQ5OUgzLjA4MzMzVjE2LjQxNjZINS45MTY2N1YxOS4yNDk5Wk01LjkxNjY3IDEzLjU4MzNIMy4wODMzM1YxMC43NDk5SDUuOTE2NjdWMTMuNTgzM1pNMTQuNDE2NyAyNC45MTY2SDExLjU4MzNWMjIuMDgzM0gxNC40MTY3VjI0LjkxNjZaTTE0LjQxNjcgMTkuMjQ5OUgxMS41ODMzVjE2LjQxNjZIMTQuNDE2N1YxOS4yNDk5Wk0xNC40MTY3IDEzLjU4MzNIMTEuNTgzM1YxMC43NDk5SDE0LjQxNjdWMTMuNTgzM1pNMTQuNDE2NyA3LjkxNjU4SDExLjU4MzNWNS4wODMyNUgxNC40MTY3VjcuOTE2NThaTTIyLjkxNjcgMjQuOTE2NkgyMC4wODMzVjIyLjA4MzNIMjIuOTE2N1YyNC45MTY2Wk0yMi45MTY3IDE5LjI0OTlIMjAuMDgzM1YxNi40MTY2SDIyLjkxNjdWMTkuMjQ5OVoiIGZpbGw9IiM0QjUyNkMiLz4KPC9zdmc+Cg==',
  },
  {
    id: 'calendar-id',
    name: 'calendar',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAyNiAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjkxNjcgMy42NjY1OUgyMS41VjAuODMzMjUySDE4LjY2NjdWMy42NjY1OUg3LjMzMzMzVjAuODMzMjUySDQuNVYzLjY2NjU5SDMuMDgzMzNDMS41MTA4MyAzLjY2NjU5IDAuMjY0MTY3IDQuOTQxNTkgMC4yNjQxNjcgNi40OTk5MkwwLjI1IDI2LjMzMzNDMC4yNSAyNy44OTE2IDEuNTEwODMgMjkuMTY2NiAzLjA4MzMzIDI5LjE2NjZIMjIuOTE2N0MyNC40NzUgMjkuMTY2NiAyNS43NSAyNy44OTE2IDI1Ljc1IDI2LjMzMzNWNi40OTk5MkMyNS43NSA0Ljk0MTU5IDI0LjQ3NSAzLjY2NjU5IDIyLjkxNjcgMy42NjY1OVpNMjIuOTE2NyAyNi4zMzMzSDMuMDgzMzNWMTIuMTY2NkgyMi45MTY3VjI2LjMzMzNaTTIyLjkxNjcgOS4zMzMyNUgzLjA4MzMzVjYuNDk5OTJIMjIuOTE2N1Y5LjMzMzI1Wk0xMyAxNi40MTY2SDIwLjA4MzNWMjMuNDk5OUgxM1YxNi40MTY2WiIgZmlsbD0iIzRCNTI2QyIvPgo8L3N2Zz4K',
  },
  {
    id: 'vehicle-id',
    name: 'vehicle',
    base64string:
      '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',
  },
  {
    id: 'headphones-id',
    name: 'headphones',
    base64string:
      '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',
  },
  {
    id: 'cycle-id',
    name: 'cycle',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNiAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjI1IDEuNDk5OTJDMC4yNSAwLjcxNzUxNSAwLjg4NDI2MyAwLjA4MzI1MiAxLjY2NjY3IDAuMDgzMjUySDI0LjMzMzNDMjUuMTE1NyAwLjA4MzI1MiAyNS43NSAwLjcxNzUxNSAyNS43NSAxLjQ5OTkyVjE5LjIwODNDMjUuNzUgMTkuOTkwNyAyNS4xMTU3IDIwLjYyNDkgMjQuMzMzMyAyMC42MjQ5SDE2LjQyMDFMMTguMjUxNyAyMi40NTY1QzE4LjgwNSAyMy4wMDk4IDE4LjgwNSAyMy45MDY3IDE4LjI1MTcgMjQuNDZDMTcuNjk4NSAyNS4wMTMyIDE2LjgwMTUgMjUuMDEzMiAxNi4yNDgzIDI0LjQ2TDExLjk5ODMgMjAuMjFDMTEuNDQ1IDE5LjY1NjcgMTEuNDQ1IDE4Ljc1OTggMTEuOTk4MyAxOC4yMDY1TDE2LjI0ODMgMTMuOTU2NUMxNi44MDE1IDEzLjQwMzMgMTcuNjk4NSAxMy40MDMzIDE4LjI1MTcgMTMuOTU2NUMxOC44MDUgMTQuNTA5OCAxOC44MDUgMTUuNDA2NyAxOC4yNTE3IDE1Ljk2TDE2LjQyMDEgMTcuNzkxNkgyMi45MTY3VjIuOTE2NTlIMy4wODMzM1YxNy43OTE2SDcuMzMzMzNDOC4xMTU3NCAxNy43OTE2IDguNzUgMTguNDI1OCA4Ljc1IDE5LjIwODNDOC43NSAxOS45OTA3IDguMTE1NzQgMjAuNjI0OSA3LjMzMzMzIDIwLjYyNDlIMS42NjY2N0MwLjg4NDI2MyAyMC42MjQ5IDAuMjUgMTkuOTkwNyAwLjI1IDE5LjIwODNWMS40OTk5MloiIGZpbGw9IiM0QjUyNkMiLz4KPC9zdmc+Cg==',
  },
  {
    id: 'document-id',
    name: 'document',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjkxNjcgMy4wODMzM1YyMi45MTY3SDMuMDgzMzNWMy4wODMzM0gyMi45MTY3Wk0yMi45MTY3IDAuMjVIMy4wODMzM0MxLjUyNSAwLjI1IDAuMjUgMS41MjUgMC4yNSAzLjA4MzMzVjIyLjkxNjdDMC4yNSAyNC40NzUgMS41MjUgMjUuNzUgMy4wODMzMyAyNS43NUgyMi45MTY3QzI0LjQ3NSAyNS43NSAyNS43NSAyNC40NzUgMjUuNzUgMjIuOTE2N1YzLjA4MzMzQzI1Ljc1IDEuNTI1IDI0LjQ3NSAwLjI1IDIyLjkxNjcgMC4yNVoiIGZpbGw9IiM0QjUyNkMiLz4KPHBhdGggZD0iTTE1LjgzMzMgMjAuMDgzM0g1LjkxNjY3VjE3LjI1SDE1LjgzMzNWMjAuMDgzM1pNMjAuMDgzMyAxNC40MTY3SDUuOTE2NjdWMTEuNTgzM0gyMC4wODMzVjE0LjQxNjdaTTIwLjA4MzMgOC43NUg1LjkxNjY3VjUuOTE2NjdIMjAuMDgzM1Y4Ljc1WiIgZmlsbD0iIzRCNTI2QyIvPgo8L3N2Zz4K',
  },
  {
    id: 'people-id',
    name: 'people',
    base64string:
      'PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAzNCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNjY2NjcgMTAuNDE2N0M3LjIyNSAxMC40MTY3IDguNSA5LjE0MTY3IDguNSA3LjU4MzMzQzguNSA2LjAyNSA3LjIyNSA0Ljc1IDUuNjY2NjcgNC43NUM0LjEwODMzIDQuNzUgMi44MzMzMyA2LjAyNSAyLjgzMzMzIDcuNTgzMzNDMi44MzMzMyA5LjE0MTY3IDQuMTA4MzMgMTAuNDE2NyA1LjY2NjY3IDEwLjQxNjdaTTcuMjY3NSAxMS45NzVDNi43NDMzMyAxMS44OSA2LjIxOTE3IDExLjgzMzMgNS42NjY2NyAxMS44MzMzQzQuMjY0MTcgMTEuODMzMyAyLjkzMjUgMTIuMTMwOCAxLjcyODMzIDEyLjY1NUMwLjY4IDEzLjEwODMgMCAxNC4xMjgzIDAgMTUuMjc1OFYxNy41SDYuMzc1VjE1LjIxOTJDNi4zNzUgMTQuMDQzMyA2LjcwMDgzIDEyLjkzODMgNy4yNjc1IDExLjk3NVpNMjguMzMzMyAxMC40MTY3QzI5Ljg5MTcgMTAuNDE2NyAzMS4xNjY3IDkuMTQxNjcgMzEuMTY2NyA3LjU4MzMzQzMxLjE2NjcgNi4wMjUgMjkuODkxNyA0Ljc1IDI4LjMzMzMgNC43NUMyNi43NzUgNC43NSAyNS41IDYuMDI1IDI1LjUgNy41ODMzM0MyNS41IDkuMTQxNjcgMjYuNzc1IDEwLjQxNjcgMjguMzMzMyAxMC40MTY3Wk0zNCAxNS4yNzU4QzM0IDE0LjEyODMgMzMuMzIgMTMuMTA4MyAzMi4yNzE3IDEyLjY1NUMzMS4wNjc1IDEyLjEzMDggMjkuNzM1OCAxMS44MzMzIDI4LjMzMzMgMTEuODMzM0MyNy43ODA4IDExLjgzMzMgMjcuMjU2NyAxMS44OSAyNi43MzI1IDExLjk3NUMyNy4yOTkyIDEyLjkzODMgMjcuNjI1IDE0LjA0MzMgMjcuNjI1IDE1LjIxOTJWMTcuNUgzNFYxNS4yNzU4Wk0yMy4wMDY3IDExLjMzNzVDMjEuMzQ5MiAxMC42MDA4IDE5LjMwOTIgMTAuMDYyNSAxNyAxMC4wNjI1QzE0LjY5MDggMTAuMDYyNSAxMi42NTA4IDEwLjYxNSAxMC45OTMzIDExLjMzNzVDOS40NjMzMyAxMi4wMTc1IDguNSAxMy41NDc1IDguNSAxNS4yMTkyVjE3LjVIMjUuNVYxNS4yMTkyQzI1LjUgMTMuNTQ3NSAyNC41MzY3IDEyLjAxNzUgMjMuMDA2NyAxMS4zMzc1Wk0xMS40MzI1IDE0LjY2NjdDMTEuNTYgMTQuMzQwOCAxMS42MTY3IDE0LjExNDIgMTIuNzIxNyAxMy42ODkyQzE0LjA5NTggMTMuMTUwOCAxNS41NDA4IDEyLjg5NTggMTcgMTIuODk1OEMxOC40NTkyIDEyLjg5NTggMTkuOTA0MiAxMy4xNTA4IDIxLjI3ODMgMTMuNjg5MkMyMi4zNjkyIDE0LjExNDIgMjIuNDI1OCAxNC4zNDA4IDIyLjU2NzUgMTQuNjY2N0gxMS40MzI1Wk0xNyAzLjMzMzMzQzE3Ljc3OTIgMy4zMzMzMyAxOC40MTY3IDMuOTcwODMgMTguNDE2NyA0Ljc1QzE4LjQxNjcgNS41MjkxNyAxNy43NzkyIDYuMTY2NjcgMTcgNi4xNjY2N0MxNi4yMjA4IDYuMTY2NjcgMTUuNTgzMyA1LjUyOTE3IDE1LjU4MzMgNC43NUMxNS41ODMzIDMuOTcwODMgMTYuMjIwOCAzLjMzMzMzIDE3IDMuMzMzMzNaTTE3IDAuNUMxNC42NDgzIDAuNSAxMi43NSAyLjM5ODMzIDEyLjc1IDQuNzVDMTIuNzUgNy4xMDE2NyAxNC42NDgzIDkgMTcgOUMxOS4zNTE3IDkgMjEuMjUgNy4xMDE2NyAyMS4yNSA0Ljc1QzIxLjI1IDIuMzk4MzMgMTkuMzUxNyAwLjUgMTcgMC41WiIgZmlsbD0iIzRCNTI2QyIvPgo8L3N2Zz4K',
  },
  {
    id: 'two-presons-id',
    name: 'two-presons',
    base64string:
      'PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAzMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjc1IDEyLjQ3OTFDNy40MzQ5OCAxMi40NzkxIDAuODMzMzEzIDE0LjEzNjYgMC44MzMzMTMgMTcuNDM3NFYxOS45MTY2SDIwLjY2NjZWMTcuNDM3NEMyMC42NjY2IDE0LjEzNjYgMTQuMDY1IDEyLjQ3OTEgMTAuNzUgMTIuNDc5MVpNNC4xNDgzMSAxNy4wODMzQzUuMzM4MzEgMTYuMjYxNiA4LjIxNDE1IDE1LjMxMjQgMTAuNzUgMTUuMzEyNEMxMy4yODU4IDE1LjMxMjQgMTYuMTYxNiAxNi4yNjE2IDE3LjM1MTYgMTcuMDgzM0g0LjE0ODMxWk0xMC43NSA5Ljk5OTkyQzEzLjQ4NDEgOS45OTk5MiAxNS43MDgzIDcuNzc1NzUgMTUuNzA4MyA1LjA0MTU4QzE1LjcwODMgMi4zMDc0MiAxMy40ODQxIDAuMDgzMjUyIDEwLjc1IDAuMDgzMjUyQzguMDE1ODEgMC4wODMyNTIgNS43OTE2NSAyLjMwNzQyIDUuNzkxNjUgNS4wNDE1OEM1Ljc5MTY1IDcuNzc1NzUgOC4wMTU4MSA5Ljk5OTkyIDEwLjc1IDkuOTk5OTJaTTEwLjc1IDIuOTE2NTlDMTEuOTI1OCAyLjkxNjU5IDEyLjg3NSAzLjg2NTc1IDEyLjg3NSA1LjA0MTU4QzEyLjg3NSA2LjIxNzQyIDExLjkyNTggNy4xNjY1OCAxMC43NSA3LjE2NjU4QzkuNTc0MTUgNy4xNjY1OCA4LjYyNDk4IDYuMjE3NDIgOC42MjQ5OCA1LjA0MTU4QzguNjI0OTggMy44NjU3NSA5LjU3NDE1IDIuOTE2NTkgMTAuNzUgMi45MTY1OVpNMjAuNzIzMyAxMi41NjQxQzIyLjM2NjYgMTMuNzU0MSAyMy41IDE1LjM0MDggMjMuNSAxNy40Mzc0VjE5LjkxNjZIMjkuMTY2NlYxNy40Mzc0QzI5LjE2NjYgMTQuNTc1OCAyNC4yMDgzIDEyLjk0NjYgMjAuNzIzMyAxMi41NjQxWk0xOS4yNSA5Ljk5OTkyQzIxLjk4NDEgOS45OTk5MiAyNC4yMDgzIDcuNzc1NzUgMjQuMjA4MyA1LjA0MTU4QzI0LjIwODMgMi4zMDc0MiAyMS45ODQxIDAuMDgzMjUyIDE5LjI1IDAuMDgzMjUyQzE4LjQ4NSAwLjA4MzI1MiAxNy43NzY2IDAuMjY3NDE4IDE3LjEyNSAwLjU3OTA4NUMxOC4wMTc1IDEuODM5OTIgMTguNTQxNiAzLjM4NDA5IDE4LjU0MTYgNS4wNDE1OEMxOC41NDE2IDYuNjk5MDkgMTguMDE3NSA4LjI0MzI1IDE3LjEyNSA5LjUwNDA4QzE3Ljc3NjYgOS44MTU3NSAxOC40ODUgOS45OTk5MiAxOS4yNSA5Ljk5OTkyWiIgZmlsbD0iIzRCNTI2QyIvPgo8L3N2Zz4K',
  },
  {
    id: 'inteligence-id',
    name: 'inteligence',
    base64string:
      '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',
  },
  {
    id: 'world-id',
    name: 'world',
    base64string:
      'PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDAuODMzMjUyQzcuMTgwMDEgMC44MzMyNTIgMC44MzMzNDQgNy4xNzk5MiAwLjgzMzM0NCAxNC45OTk5QzAuODMzMzQ0IDIyLjgxOTkgNy4xODAwMSAyOS4xNjY2IDE1IDI5LjE2NjZDMjIuODIgMjkuMTY2NiAyOS4xNjY3IDIyLjgxOTkgMjkuMTY2NyAxNC45OTk5QzI5LjE2NjcgNy4xNzk5MiAyMi44MiAwLjgzMzI1MiAxNSAwLjgzMzI1MlpNMy42NjY2OCAxNC45OTk5QzMuNjY2NjggMTQuMTM1OCAzLjc4MDAxIDEzLjI4NTggMy45NjQxOCAxMi40NzgzTDEwLjczNTggMTkuMjQ5OVYyMC42NjY2QzEwLjczNTggMjIuMjI0OSAxMi4wMTA4IDIzLjQ5OTkgMTMuNTY5MiAyMy40OTk5VjI2LjIzNDFDOC4wMDE2OCAyNS41MjU4IDMuNjY2NjggMjAuNzY1OCAzLjY2NjY4IDE0Ljk5OTlaTTIzLjM0NDIgMjIuNjQ5OUMyMi45NzU4IDIxLjUwMjQgMjEuOTI3NSAyMC42NjY2IDIwLjY1MjUgMjAuNjY2NkgxOS4yMzU4VjE2LjQxNjZDMTkuMjM1OCAxNS42Mzc0IDE4LjU5ODMgMTQuOTk5OSAxNy44MTkyIDE0Ljk5OTlIOS4zMTkxOFYxMi4xNjY2SDEyLjE1MjVDMTIuOTMxNyAxMi4xNjY2IDEzLjU2OTIgMTEuNTI5MSAxMy41NjkyIDEwLjc0OTlWNy45MTY1OEgxNi40MDI1QzE3Ljk2MDggNy45MTY1OCAxOS4yMzU4IDYuNjQxNTkgMTkuMjM1OCA1LjA4MzI1VjQuNTAyNDJDMjMuMzg2NyA2LjE3NDA5IDI2LjMzMzMgMTAuMjU0MSAyNi4zMzMzIDE0Ljk5OTlDMjYuMzMzMyAxNy45NDY2IDI1LjE4NTggMjAuNjM4MyAyMy4zNDQyIDIyLjY0OTlaIiBmaWxsPSIjNEI1MjZDIi8+Cjwvc3ZnPgo=',
  },
  {
    id: 'wave-id',
    name: 'wave',
    base64string:
      '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',
  },
  {
    id: 'clipnote-id',
    name: 'clipnote',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCAyNiAzMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1Ljc1IDMuNjY2NTlIMTYuOTk1QzE2LjQgMi4wMjMyNSAxNC44NDE3IDAuODMzMjUyIDEzIDAuODMzMjUyQzExLjE1ODMgMC44MzMyNTIgOS42IDIuMDIzMjUgOS4wMDUgMy42NjY1OUgwLjI1VjMwLjU4MzNIMjUuNzVWMy42NjY1OVpNMTMgMy42NjY1OUMxMy43NzkyIDMuNjY2NTkgMTQuNDE2NyA0LjMwNDA5IDE0LjQxNjcgNS4wODMyNUMxNC40MTY3IDUuODYyNDIgMTMuNzc5MiA2LjQ5OTkyIDEzIDYuNDk5OTJDMTIuMjIwOCA2LjQ5OTkyIDExLjU4MzMgNS44NjI0MiAxMS41ODMzIDUuMDgzMjVDMTEuNTgzMyA0LjMwNDA5IDEyLjIyMDggMy42NjY1OSAxMyAzLjY2NjU5Wk0yMi45MTY3IDI3Ljc0OTlIMy4wODMzM1Y2LjQ5OTkySDUuOTE2NjdWMTAuNzQ5OUgyMC4wODMzVjYuNDk5OTJIMjIuOTE2N1YyNy43NDk5WiIgZmlsbD0iIzRCNTI2QyIvPgo8L3N2Zz4K',
  },
  {
    id: 'tasklist-id',
    name: 'tasklist',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjU4MzMgNS45MTY2N0gyMC4wODMzVjguNzVIMTEuNTgzM1Y1LjkxNjY3Wk0xMS41ODMzIDExLjU4MzNIMjAuMDgzM1YxNC40MTY3SDExLjU4MzNWMTEuNTgzM1pNMTEuNTgzMyAxNy4yNUgyMC4wODMzVjIwLjA4MzNIMTEuNTgzM1YxNy4yNVpNNS45MTY2NyA1LjkxNjY3SDguNzVWOC43NUg1LjkxNjY3VjUuOTE2NjdaTTUuOTE2NjcgMTEuNTgzM0g4Ljc1VjE0LjQxNjdINS45MTY2N1YxMS41ODMzWk01LjkxNjY3IDE3LjI1SDguNzVWMjAuMDgzM0g1LjkxNjY3VjE3LjI1Wk0yNC40NzUgMC4yNUgxLjUyNUMwLjgxNjY2NyAwLjI1IDAuMjUgMC44MTY2NjcgMC4yNSAxLjUyNVYyNC40NzVDMC4yNSAyNS4wNDE3IDAuODE2NjY3IDI1Ljc1IDEuNTI1IDI1Ljc1SDI0LjQ3NUMyNS4wNDE3IDI1Ljc1IDI1Ljc1IDI1LjA0MTcgMjUuNzUgMjQuNDc1VjEuNTI1QzI1Ljc1IDAuODE2NjY3IDI1LjA0MTcgMC4yNSAyNC40NzUgMC4yNVpNMjIuOTE2NyAyMi45MTY3SDMuMDgzMzNWMy4wODMzM0gyMi45MTY3VjIyLjkxNjdaIiBmaWxsPSIjNEI1MjZDIi8+Cjwvc3ZnPgo=',
  },
  {
    id: 'diagram-id',
    name: 'diagram',
    base64string:
      'PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAzMCAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5LjE2NjcgMTEuNTgzM1YwLjI1SDE5LjI1VjQuNUgxMC43NVYwLjI1SDAuODMzMzQ0VjExLjU4MzNIMTAuNzVWNy4zMzMzM0gxMy41ODMzVjIxLjVIMTkuMjVWMjUuNzVIMjkuMTY2N1YxNC40MTY3SDE5LjI1VjE4LjY2NjdIMTYuNDE2N1Y3LjMzMzMzSDE5LjI1VjExLjU4MzNIMjkuMTY2N1pNNy45MTY2OCA4Ljc1SDMuNjY2NjhWMy4wODMzM0g3LjkxNjY4VjguNzVaTTIyLjA4MzMgMTcuMjVIMjYuMzMzM1YyMi45MTY3SDIyLjA4MzNWMTcuMjVaTTIyLjA4MzMgMy4wODMzM0gyNi4zMzMzVjguNzVIMjIuMDgzM1YzLjA4MzMzWiIgZmlsbD0iIzRCNTI2QyIvPgo8L3N2Zz4K',
  },
  {
    id: 'highest-id',
    name: 'highes',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1Ljc1IDE3LjVMMjUuNzUgOUwxMyAwLjQ5OTk5OUwwLjI1IDlMMC4yNDk5OTkgMTcuNUwxMyA5TDI1Ljc1IDE3LjVaIiBmaWxsPSIjNEI1MjZDIi8+Cjwvc3ZnPgo=',
  },
  {
    id: 'high-id',
    name: 'high',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAyNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1Ljc1IDEzLjY2NjdMMjUuNzUgOS40MTY3NEwxMyAwLjkxNjc0OEwwLjI1IDkuNDE2NzRMMC4yNDk5OTkgMTMuNjY2N0wxMyA1LjE2Njc1TDI1Ljc1IDEzLjY2NjdaIiBmaWxsPSIjNEI1MjZDIi8+Cjwvc3ZnPgo=',
  },
  {
    id: 'medium-id',
    name: 'medium',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDI2IDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yNS43NSA0LjQxNjc1TDI1Ljc1IDAuMTY2NzQ4TDEzIDAuMTY2NzQ4TDAuMjUgMC4xNjY3NDlMMC4yNSA0LjQxNjc1TDEzIDQuNDE2NzVMMjUuNzUgNC40MTY3NVoiIGZpbGw9IiM0QjUyNkMiLz4KPC9zdmc+Cg==',
  },
  {
    id: 'low-id',
    name: 'low',
    base64string:
      'PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAyNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMjQ5OTk5IDAuMzMzMjUxTDAuMjUwMDAxIDQuNTgzMjZMMTMgMTMuMDgzM0wyNS43NSA0LjU4MzI1TDI1Ljc1IDAuMzMzMjQ5TDEzIDguODMzMjVMMC4yNDk5OTkgMC4zMzMyNTFaIiBmaWxsPSIjNEI1MjZDIi8+Cjwvc3ZnPgo=',
  },
]

export const countries = {
  AF: {
    name: 'Afghanistan',
    region: 'Asia',
    timezones: {
      'Asia/Kabul': '+04:30',
    },
    iso: {
      'alpha-2': 'AF',
      'alpha-3': 'AFG',
      numeric: '004',
    },
    phone: ['+93'],
    emoji: '\ud83c\udde6\ud83c\uddeb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg',
  },
  AL: {
    name: 'Albania',
    region: 'Europe',
    timezones: {
      'Europe/Tirane': '+02:00',
    },
    iso: {
      'alpha-2': 'AL',
      'alpha-3': 'ALB',
      numeric: '008',
    },
    phone: ['+355'],
    emoji: '\ud83c\udde6\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg',
  },
  DZ: {
    name: 'Algeria',
    region: 'Africa',
    timezones: {
      'Africa/Algiers': '+01:00',
    },
    iso: {
      'alpha-2': 'DZ',
      'alpha-3': 'DZA',
      numeric: '012',
    },
    phone: ['+213'],
    emoji: '\ud83c\udde9\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg',
  },
  AS: {
    name: 'American Samoa',
    region: 'Oceania',
    timezones: {
      'Pacific/Pago_Pago': '-11:00',
    },
    iso: {
      'alpha-2': 'AS',
      'alpha-3': 'ASM',
      numeric: '016',
    },
    phone: ['+1-684'],
    emoji: '\ud83c\udde6\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg',
  },
  AD: {
    name: 'Andorra',
    region: 'Europe',
    timezones: {
      'Europe/Andorra': '+02:00',
    },
    iso: {
      'alpha-2': 'AD',
      'alpha-3': 'AND',
      numeric: '020',
    },
    phone: ['+376'],
    emoji: '\ud83c\udde6\ud83c\udde9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg',
  },
  AO: {
    name: 'Angola',
    region: 'Africa',
    timezones: {
      'Africa/Luanda': '+01:00',
    },
    iso: {
      'alpha-2': 'AO',
      'alpha-3': 'AGO',
      numeric: '024',
    },
    phone: ['+244'],
    emoji: '\ud83c\udde6\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg',
  },
  AI: {
    name: 'Anguilla',
    region: 'Americas',
    timezones: {
      'America/Anguilla': '-04:00',
    },
    iso: {
      'alpha-2': 'AI',
      'alpha-3': 'AIA',
      numeric: '660',
    },
    phone: ['+1-264'],
    emoji: '\ud83c\udde6\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg',
  },
  AQ: {
    name: 'Antarctica',
    region: '',
    timezones: {
      'Antarctica/Casey': '+11:00',
      'Antarctica/Davis': '+07:00',
      'Antarctica/DumontDUrville': '+10:00',
      'Antarctica/Mawson': '+05:00',
      'Antarctica/McMurdo': '+12:00',
      'Antarctica/Palmer': '-03:00',
      'Antarctica/Rothera': '-03:00',
      'Antarctica/Syowa': '+03:00',
      'Antarctica/Troll': '+02:00',
      'Antarctica/Vostok': '+06:00',
    },
    iso: {
      'alpha-2': 'AQ',
      'alpha-3': 'ATA',
      numeric: '010',
    },
    phone: ['+'],
    emoji: '\ud83c\udde6\ud83c\uddf6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AQ.svg',
  },
  AG: {
    name: 'Antigua and Barbuda',
    region: 'Americas',
    timezones: {
      'America/Antigua': '-04:00',
    },
    iso: {
      'alpha-2': 'AG',
      'alpha-3': 'ATG',
      numeric: '028',
    },
    phone: ['+1-268'],
    emoji: '\ud83c\udde6\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AG.svg',
  },
  AR: {
    name: 'Argentina',
    region: 'Americas',
    timezones: {
      'America/Argentina/Buenos_Aires': '-03:00',
      'America/Argentina/Catamarca': '-03:00',
      'America/Argentina/Cordoba': '-03:00',
      'America/Argentina/Jujuy': '-03:00',
      'America/Argentina/La_Rioja': '-03:00',
      'America/Argentina/Mendoza': '-03:00',
      'America/Argentina/Rio_Gallegos': '-03:00',
      'America/Argentina/Salta': '-03:00',
      'America/Argentina/San_Juan': '-03:00',
      'America/Argentina/San_Luis': '-03:00',
      'America/Argentina/Tucuman': '-03:00',
      'America/Argentina/Ushuaia': '-03:00',
    },
    iso: {
      'alpha-2': 'AR',
      'alpha-3': 'ARG',
      numeric: '032',
    },
    phone: ['+54'],
    emoji: '\ud83c\udde6\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg',
  },
  AM: {
    name: 'Armenia',
    region: 'Asia',
    timezones: {
      'Asia/Yerevan': '+04:00',
    },
    iso: {
      'alpha-2': 'AM',
      'alpha-3': 'ARM',
      numeric: '051',
    },
    phone: ['+374'],
    emoji: '\ud83c\udde6\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg',
  },
  AW: {
    name: 'Aruba',
    region: 'Americas',
    timezones: {
      'America/Aruba': '-04:00',
    },
    iso: {
      'alpha-2': 'AW',
      'alpha-3': 'ABW',
      numeric: '533',
    },
    phone: ['+297'],
    emoji: '\ud83c\udde6\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg',
  },
  AU: {
    name: 'Australia',
    region: 'Oceania',
    timezones: {
      'Antarctica/Macquarie': '+10:00',
      'Australia/Adelaide': '+09:30',
      'Australia/Brisbane': '+10:00',
      'Australia/Broken_Hill': '+09:30',
      'Australia/Darwin': '+09:30',
      'Australia/Eucla': '+08:45',
      'Australia/Hobart': '+10:00',
      'Australia/Lindeman': '+10:00',
      'Australia/Lord_Howe': '+10:30',
      'Australia/Melbourne': '+10:00',
      'Australia/Perth': '+08:00',
      'Australia/Sydney': '+10:00',
    },
    iso: {
      'alpha-2': 'AU',
      'alpha-3': 'AUS',
      numeric: '036',
    },
    phone: ['+61'],
    emoji: '\ud83c\udde6\ud83c\uddfa',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg',
  },
  AT: {
    name: 'Austria',
    region: 'Europe',
    timezones: {
      'Europe/Vienna': '+02:00',
    },
    iso: {
      'alpha-2': 'AT',
      'alpha-3': 'AUT',
      numeric: '040',
    },
    phone: ['+43'],
    emoji: '\ud83c\udde6\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg',
  },
  AZ: {
    name: 'Azerbaijan',
    region: 'Asia',
    timezones: {
      'Asia/Baku': '+04:00',
    },
    iso: {
      'alpha-2': 'AZ',
      'alpha-3': 'AZE',
      numeric: '031',
    },
    phone: ['+994'],
    emoji: '\ud83c\udde6\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg',
  },
  BS: {
    name: 'Bahamas',
    region: 'Americas',
    timezones: {
      'America/Nassau': '-04:00',
    },
    iso: {
      'alpha-2': 'BS',
      'alpha-3': 'BHS',
      numeric: '044',
    },
    phone: ['+1-242'],
    emoji: '\ud83c\udde7\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg',
  },
  BH: {
    name: 'Bahrain',
    region: 'Asia',
    timezones: {
      'Asia/Bahrain': '+03:00',
    },
    iso: {
      'alpha-2': 'BH',
      'alpha-3': 'BHR',
      numeric: '048',
    },
    phone: ['+973'],
    emoji: '\ud83c\udde7\ud83c\udded',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg',
  },
  BD: {
    name: 'Bangladesh',
    region: 'Asia',
    timezones: {
      'Asia/Dhaka': '+06:00',
    },
    iso: {
      'alpha-2': 'BD',
      'alpha-3': 'BGD',
      numeric: '050',
    },
    phone: ['+880'],
    emoji: '\ud83c\udde7\ud83c\udde9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg',
  },
  BB: {
    name: 'Barbados',
    region: 'Americas',
    timezones: {
      'America/Barbados': '-04:00',
    },
    iso: {
      'alpha-2': 'BB',
      'alpha-3': 'BRB',
      numeric: '052',
    },
    phone: ['+1-246'],
    emoji: '\ud83c\udde7\ud83c\udde7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg',
  },
  BY: {
    name: 'Belarus',
    region: 'Europe',
    timezones: {
      'Europe/Minsk': '+03:00',
    },
    iso: {
      'alpha-2': 'BY',
      'alpha-3': 'BLR',
      numeric: '112',
    },
    phone: ['+375'],
    emoji: '\ud83c\udde7\ud83c\uddfe',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg',
  },
  BE: {
    name: 'Belgium',
    region: 'Europe',
    timezones: {
      'Europe/Brussels': '+02:00',
    },
    iso: {
      'alpha-2': 'BE',
      'alpha-3': 'BEL',
      numeric: '056',
    },
    phone: ['+32'],
    emoji: '\ud83c\udde7\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg',
  },
  BZ: {
    name: 'Belize',
    region: 'Americas',
    timezones: {
      'America/Belize': '-06:00',
    },
    iso: {
      'alpha-2': 'BZ',
      'alpha-3': 'BLZ',
      numeric: '084',
    },
    phone: ['+501'],
    emoji: '\ud83c\udde7\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg',
  },
  BJ: {
    name: 'Benin',
    region: 'Africa',
    timezones: {
      'Africa/Porto-Novo': '+01:00',
    },
    iso: {
      'alpha-2': 'BJ',
      'alpha-3': 'BEN',
      numeric: '204',
    },
    phone: ['+229'],
    emoji: '\ud83c\udde7\ud83c\uddef',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg',
  },
  BM: {
    name: 'Bermuda',
    region: 'Americas',
    timezones: {
      'Atlantic/Bermuda': '-03:00',
    },
    iso: {
      'alpha-2': 'BM',
      'alpha-3': 'BMU',
      numeric: '060',
    },
    phone: ['+1-441'],
    emoji: '\ud83c\udde7\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg',
  },
  BT: {
    name: 'Bhutan',
    region: 'Asia',
    timezones: {
      'Asia/Thimphu': '+06:00',
    },
    iso: {
      'alpha-2': 'BT',
      'alpha-3': 'BTN',
      numeric: '064',
    },
    phone: ['+975'],
    emoji: '\ud83c\udde7\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg',
  },
  BO: {
    name: 'Bolivia, Plurinational State of',
    region: 'Americas',
    timezones: {
      'America/La_Paz': '-04:00',
    },
    iso: {
      'alpha-2': 'BO',
      'alpha-3': 'BOL',
      numeric: '068',
    },
    phone: ['+591'],
    emoji: '\ud83c\udde7\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BO.svg',
  },
  BQ: {
    name: 'Bonaire, Sint Eustatius and Saba',
    region: 'Americas',
    timezones: {
      'America/Kralendijk': '-04:00',
    },
    iso: {
      'alpha-2': 'BQ',
      'alpha-3': 'BES',
      numeric: '535',
    },
    phone: ['+599'],
    emoji: '\ud83c\udde7\ud83c\uddf6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BQ.svg',
  },
  BA: {
    name: 'Bosnia and Herzegovina',
    region: 'Europe',
    timezones: {
      'Europe/Sarajevo': '+02:00',
    },
    iso: {
      'alpha-2': 'BA',
      'alpha-3': 'BIH',
      numeric: '070',
    },
    phone: ['+387'],
    emoji: '\ud83c\udde7\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BA.svg',
  },
  BW: {
    name: 'Botswana',
    region: 'Africa',
    timezones: {
      'Africa/Gaborone': '+02:00',
    },
    iso: {
      'alpha-2': 'BW',
      'alpha-3': 'BWA',
      numeric: '072',
    },
    phone: ['+267'],
    emoji: '\ud83c\udde7\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg',
  },
  BR: {
    name: 'Brazil',
    region: 'Americas',
    timezones: {
      'America/Araguaina': '-03:00',
      'America/Bahia': '-03:00',
      'America/Belem': '-03:00',
      'America/Boa_Vista': '-04:00',
      'America/Campo_Grande': '-04:00',
      'America/Cuiaba': '-04:00',
      'America/Eirunepe': '-05:00',
      'America/Fortaleza': '-03:00',
      'America/Maceio': '-03:00',
      'America/Manaus': '-04:00',
      'America/Noronha': '-02:00',
      'America/Porto_Velho': '-04:00',
      'America/Recife': '-03:00',
      'America/Rio_Branco': '-05:00',
      'America/Santarem': '-03:00',
      'America/Sao_Paulo': '-03:00',
    },
    iso: {
      'alpha-2': 'BR',
      'alpha-3': 'BRA',
      numeric: '076',
    },
    phone: ['+55'],
    emoji: '\ud83c\udde7\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg',
  },
  IO: {
    name: 'British Indian Ocean Territory',
    region: 'Africa',
    timezones: {
      'Indian/Chagos': '+06:00',
    },
    iso: {
      'alpha-2': 'IO',
      'alpha-3': 'IOT',
      numeric: '086',
    },
    phone: ['+246'],
    emoji: '\ud83c\uddee\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg',
  },
  BN: {
    name: 'Brunei Darussalam',
    region: 'Asia',
    timezones: {
      'Asia/Brunei': '+08:00',
    },
    iso: {
      'alpha-2': 'BN',
      'alpha-3': 'BRN',
      numeric: '096',
    },
    phone: ['+673'],
    emoji: '\ud83c\udde7\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BN.svg',
  },
  BG: {
    name: 'Bulgaria',
    region: 'Europe',
    timezones: {
      'Europe/Sofia': '+03:00',
    },
    iso: {
      'alpha-2': 'BG',
      'alpha-3': 'BGR',
      numeric: '100',
    },
    phone: ['+359'],
    emoji: '\ud83c\udde7\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg',
  },
  BF: {
    name: 'Burkina Faso',
    region: 'Africa',
    timezones: {
      'Africa/Ouagadougou': '+00:00',
    },
    iso: {
      'alpha-2': 'BF',
      'alpha-3': 'BFA',
      numeric: '854',
    },
    phone: ['+226'],
    emoji: '\ud83c\udde7\ud83c\uddeb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg',
  },
  BI: {
    name: 'Burundi',
    region: 'Africa',
    timezones: {
      'Africa/Bujumbura': '+02:00',
    },
    iso: {
      'alpha-2': 'BI',
      'alpha-3': 'BDI',
      numeric: '108',
    },
    phone: ['+257'],
    emoji: '\ud83c\udde7\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg',
  },
  KH: {
    name: 'Cambodia',
    region: 'Asia',
    timezones: {
      'Asia/Phnom_Penh': '+07:00',
    },
    iso: {
      'alpha-2': 'KH',
      'alpha-3': 'KHM',
      numeric: '116',
    },
    phone: ['+855'],
    emoji: '\ud83c\uddf0\ud83c\udded',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg',
  },
  CM: {
    name: 'Cameroon',
    region: 'Africa',
    timezones: {
      'Africa/Douala': '+01:00',
    },
    iso: {
      'alpha-2': 'CM',
      'alpha-3': 'CMR',
      numeric: '120',
    },
    phone: ['+237'],
    emoji: '\ud83c\udde8\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg',
  },
  CA: {
    name: 'Canada',
    region: 'Americas',
    timezones: {
      'America/Atikokan': '-05:00',
      'America/Blanc-Sablon': '-04:00',
      'America/Cambridge_Bay': '-06:00',
      'America/Creston': '-07:00',
      'America/Dawson': '-07:00',
      'America/Dawson_Creek': '-07:00',
      'America/Edmonton': '-06:00',
      'America/Fort_Nelson': '-07:00',
      'America/Glace_Bay': '-03:00',
      'America/Goose_Bay': '-03:00',
      'America/Halifax': '-03:00',
      'America/Inuvik': '-06:00',
      'America/Iqaluit': '-04:00',
      'America/Moncton': '-03:00',
      'America/Rankin_Inlet': '-05:00',
      'America/Regina': '-06:00',
      'America/Resolute': '-05:00',
      'America/St_Johns': '-02:30',
      'America/Swift_Current': '-06:00',
      'America/Toronto': '-04:00',
      'America/Vancouver': '-07:00',
      'America/Whitehorse': '-07:00',
      'America/Winnipeg': '-05:00',
    },
    iso: {
      'alpha-2': 'CA',
      'alpha-3': 'CAN',
      numeric: '124',
    },
    phone: ['+1'],
    emoji: '\ud83c\udde8\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg',
  },
  CV: {
    name: 'Cape Verde',
    region: 'Africa',
    timezones: {
      'Atlantic/Cape_Verde': '-01:00',
    },
    iso: {
      'alpha-2': 'CV',
      'alpha-3': 'CPV',
      numeric: '132',
    },
    phone: ['+238'],
    emoji: '\ud83c\udde8\ud83c\uddfb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg',
  },
  KY: {
    name: 'Cayman Islands',
    region: 'Americas',
    timezones: {
      'America/Cayman': '-05:00',
    },
    iso: {
      'alpha-2': 'KY',
      'alpha-3': 'CYM',
      numeric: '136',
    },
    phone: ['+1-345'],
    emoji: '\ud83c\uddf0\ud83c\uddfe',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg',
  },
  CF: {
    name: 'Central African Republic',
    region: 'Africa',
    timezones: {
      'Africa/Bangui': '+01:00',
    },
    iso: {
      'alpha-2': 'CF',
      'alpha-3': 'CAF',
      numeric: '140',
    },
    phone: ['+236'],
    emoji: '\ud83c\udde8\ud83c\uddeb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg',
  },
  TD: {
    name: 'Chad',
    region: 'Africa',
    timezones: {
      'Africa/Ndjamena': '+01:00',
    },
    iso: {
      'alpha-2': 'TD',
      'alpha-3': 'TCD',
      numeric: '148',
    },
    phone: ['+235'],
    emoji: '\ud83c\uddf9\ud83c\udde9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg',
  },
  CL: {
    name: 'Chile',
    region: 'Americas',
    timezones: {
      'America/Punta_Arenas': '-03:00',
      'America/Santiago': '-04:00',
      'Pacific/Easter': '-06:00',
    },
    iso: {
      'alpha-2': 'CL',
      'alpha-3': 'CHL',
      numeric: '152',
    },
    phone: ['+56'],
    emoji: '\ud83c\udde8\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg',
  },
  CN: {
    name: 'China',
    region: 'Asia',
    timezones: {
      'Asia/Shanghai': '+08:00',
      'Asia/Urumqi': '+06:00',
    },
    iso: {
      'alpha-2': 'CN',
      'alpha-3': 'CHN',
      numeric: '156',
    },
    phone: ['+86'],
    emoji: '\ud83c\udde8\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg',
  },
  CX: {
    name: 'Christmas Island',
    region: 'Oceania',
    timezones: {
      'Indian/Christmas': '+07:00',
    },
    iso: {
      'alpha-2': 'CX',
      'alpha-3': 'CXR',
      numeric: '162',
    },
    phone: ['+61'],
    emoji: '\ud83c\udde8\ud83c\uddfd',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg',
  },
  CC: {
    name: 'Cocos (Keeling) Islands',
    region: 'Oceania',
    timezones: {
      'Indian/Cocos': '+06:30',
    },
    iso: {
      'alpha-2': 'CC',
      'alpha-3': 'CCK',
      numeric: '166',
    },
    phone: ['+61'],
    emoji: '\ud83c\udde8\ud83c\udde8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CC.svg',
  },
  CO: {
    name: 'Colombia',
    region: 'Americas',
    timezones: {
      'America/Bogota': '-05:00',
    },
    iso: {
      'alpha-2': 'CO',
      'alpha-3': 'COL',
      numeric: '170',
    },
    phone: ['+57'],
    emoji: '\ud83c\udde8\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg',
  },
  KM: {
    name: 'Comoros',
    region: 'Africa',
    timezones: {
      'Indian/Comoro': '+03:00',
    },
    iso: {
      'alpha-2': 'KM',
      'alpha-3': 'COM',
      numeric: '174',
    },
    phone: ['+269'],
    emoji: '\ud83c\uddf0\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg',
  },
  CG: {
    name: 'Congo',
    region: 'Africa',
    timezones: {
      'Africa/Brazzaville': '+01:00',
    },
    iso: {
      'alpha-2': 'CG',
      'alpha-3': 'COG',
      numeric: '178',
    },
    phone: ['+242'],
    emoji: '\ud83c\udde8\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CG.svg',
  },
  CD: {
    name: 'Congo, the Democratic Republic of the',
    region: 'Africa',
    timezones: {
      'Africa/Kinshasa': '+01:00',
      'Africa/Lubumbashi': '+02:00',
    },
    iso: {
      'alpha-2': 'CD',
      'alpha-3': 'COD',
      numeric: '180',
    },
    phone: ['+243'],
    emoji: '\ud83c\udde8\ud83c\udde9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CD.svg',
  },
  CK: {
    name: 'Cook Islands',
    region: 'Oceania',
    timezones: {
      'Pacific/Rarotonga': '-10:00',
    },
    iso: {
      'alpha-2': 'CK',
      'alpha-3': 'COK',
      numeric: '184',
    },
    phone: ['+682'],
    emoji: '\ud83c\udde8\ud83c\uddf0',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg',
  },
  CR: {
    name: 'Costa Rica',
    region: 'Americas',
    timezones: {
      'America/Costa_Rica': '-06:00',
    },
    iso: {
      'alpha-2': 'CR',
      'alpha-3': 'CRI',
      numeric: '188',
    },
    phone: ['+506'],
    emoji: '\ud83c\udde8\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg',
  },
  HR: {
    name: 'Croatia',
    region: 'Europe',
    timezones: {
      'Europe/Zagreb': '+02:00',
    },
    iso: {
      'alpha-2': 'HR',
      'alpha-3': 'HRV',
      numeric: '191',
    },
    phone: ['+385'],
    emoji: '\ud83c\udded\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg',
  },
  CU: {
    name: 'Cuba',
    region: 'Americas',
    timezones: {
      'America/Havana': '-04:00',
    },
    iso: {
      'alpha-2': 'CU',
      'alpha-3': 'CUB',
      numeric: '192',
    },
    phone: ['+53'],
    emoji: '\ud83c\udde8\ud83c\uddfa',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg',
  },
  CW: {
    name: 'Cura\u00e7ao',
    region: 'Americas',
    timezones: {
      'America/Curacao': '-04:00',
    },
    iso: {
      'alpha-2': 'CW',
      'alpha-3': 'CUW',
      numeric: '531',
    },
    phone: ['+599'],
    emoji: '\ud83c\udde8\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CW.svg',
  },
  CY: {
    name: 'Cyprus',
    region: 'Asia',
    timezones: {
      'Asia/Famagusta': '+03:00',
      'Asia/Nicosia': '+03:00',
    },
    iso: {
      'alpha-2': 'CY',
      'alpha-3': 'CYP',
      numeric: '196',
    },
    phone: ['+357'],
    emoji: '\ud83c\udde8\ud83c\uddfe',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg',
  },
  CZ: {
    name: 'Czech Republic',
    region: 'Europe',
    timezones: {
      'Europe/Prague': '+02:00',
    },
    iso: {
      'alpha-2': 'CZ',
      'alpha-3': 'CZE',
      numeric: '203',
    },
    phone: ['+420'],
    emoji: '\ud83c\udde8\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CZ.svg',
  },
  CI: {
    name: "C\u00f4te d'Ivoire",
    region: 'Africa',
    timezones: {
      'Africa/Abidjan': '+00:00',
    },
    iso: {
      'alpha-2': 'CI',
      'alpha-3': 'CIV',
      numeric: '384',
    },
    phone: ['+225'],
    emoji: '\ud83c\udde8\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CI.svg',
  },
  DK: {
    name: 'Denmark',
    region: 'Europe',
    timezones: {
      'Europe/Copenhagen': '+02:00',
    },
    iso: {
      'alpha-2': 'DK',
      'alpha-3': 'DNK',
      numeric: '208',
    },
    phone: ['+45'],
    emoji: '\ud83c\udde9\ud83c\uddf0',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg',
  },
  DJ: {
    name: 'Djibouti',
    region: 'Africa',
    timezones: {
      'Africa/Djibouti': '+03:00',
    },
    iso: {
      'alpha-2': 'DJ',
      'alpha-3': 'DJI',
      numeric: '262',
    },
    phone: ['+253'],
    emoji: '\ud83c\udde9\ud83c\uddef',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg',
  },
  DM: {
    name: 'Dominica',
    region: 'Americas',
    timezones: {
      'America/Dominica': '-04:00',
    },
    iso: {
      'alpha-2': 'DM',
      'alpha-3': 'DMA',
      numeric: '212',
    },
    phone: ['+1-767'],
    emoji: '\ud83c\udde9\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg',
  },
  DO: {
    name: 'Dominican Republic',
    region: 'Americas',
    timezones: {
      'America/Santo_Domingo': '-04:00',
    },
    iso: {
      'alpha-2': 'DO',
      'alpha-3': 'DOM',
      numeric: '214',
    },
    phone: ['+1-809', '+1-829'],
    emoji: '\ud83c\udde9\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg',
  },
  EC: {
    name: 'Ecuador',
    region: 'Americas',
    timezones: {
      'America/Guayaquil': '-05:00',
      'Pacific/Galapagos': '-06:00',
    },
    iso: {
      'alpha-2': 'EC',
      'alpha-3': 'ECU',
      numeric: '218',
    },
    phone: ['+593'],
    emoji: '\ud83c\uddea\ud83c\udde8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg',
  },
  EG: {
    name: 'Egypt',
    region: 'Africa',
    timezones: {
      'Africa/Cairo': '+02:00',
    },
    iso: {
      'alpha-2': 'EG',
      'alpha-3': 'EGY',
      numeric: '818',
    },
    phone: ['+20'],
    emoji: '\ud83c\uddea\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg',
  },
  SV: {
    name: 'El Salvador',
    region: 'Americas',
    timezones: {
      'America/El_Salvador': '-06:00',
    },
    iso: {
      'alpha-2': 'SV',
      'alpha-3': 'SLV',
      numeric: '222',
    },
    phone: ['+503'],
    emoji: '\ud83c\uddf8\ud83c\uddfb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg',
  },
  GQ: {
    name: 'Equatorial Guinea',
    region: 'Africa',
    timezones: {
      'Africa/Malabo': '+01:00',
    },
    iso: {
      'alpha-2': 'GQ',
      'alpha-3': 'GNQ',
      numeric: '226',
    },
    phone: ['+240'],
    emoji: '\ud83c\uddec\ud83c\uddf6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg',
  },
  ER: {
    name: 'Eritrea',
    region: 'Africa',
    timezones: {
      'Africa/Asmara': '+03:00',
    },
    iso: {
      'alpha-2': 'ER',
      'alpha-3': 'ERI',
      numeric: '232',
    },
    phone: ['+291'],
    emoji: '\ud83c\uddea\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg',
  },
  EE: {
    name: 'Estonia',
    region: 'Europe',
    timezones: {
      'Europe/Tallinn': '+03:00',
    },
    iso: {
      'alpha-2': 'EE',
      'alpha-3': 'EST',
      numeric: '233',
    },
    phone: ['+372'],
    emoji: '\ud83c\uddea\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg',
  },
  ET: {
    name: 'Ethiopia',
    region: 'Africa',
    timezones: {
      'Africa/Addis_Ababa': '+03:00',
    },
    iso: {
      'alpha-2': 'ET',
      'alpha-3': 'ETH',
      numeric: '231',
    },
    phone: ['+251'],
    emoji: '\ud83c\uddea\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg',
  },
  FK: {
    name: 'Falkland Islands (Malvinas)',
    region: 'Americas',
    timezones: {
      'Atlantic/Stanley': '-03:00',
    },
    iso: {
      'alpha-2': 'FK',
      'alpha-3': 'FLK',
      numeric: '238',
    },
    phone: ['+500'],
    emoji: '\ud83c\uddeb\ud83c\uddf0',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FK.svg',
  },
  FO: {
    name: 'Faroe Islands',
    region: 'Europe',
    timezones: {
      'Atlantic/Faroe': '+01:00',
    },
    iso: {
      'alpha-2': 'FO',
      'alpha-3': 'FRO',
      numeric: '234',
    },
    phone: ['+298'],
    emoji: '\ud83c\uddeb\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg',
  },
  FJ: {
    name: 'Fiji',
    region: 'Oceania',
    timezones: {
      'Pacific/Fiji': '+12:00',
    },
    iso: {
      'alpha-2': 'FJ',
      'alpha-3': 'FJI',
      numeric: '242',
    },
    phone: ['+679'],
    emoji: '\ud83c\uddeb\ud83c\uddef',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg',
  },
  FI: {
    name: 'Finland',
    region: 'Europe',
    timezones: {
      'Europe/Helsinki': '+03:00',
    },
    iso: {
      'alpha-2': 'FI',
      'alpha-3': 'FIN',
      numeric: '246',
    },
    phone: ['+358'],
    emoji: '\ud83c\uddeb\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg',
  },
  FR: {
    name: 'France',
    region: 'Europe',
    timezones: {
      'Europe/Paris': '+02:00',
    },
    iso: {
      'alpha-2': 'FR',
      'alpha-3': 'FRA',
      numeric: '250',
    },
    phone: ['+33'],
    emoji: '\ud83c\uddeb\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg',
  },
  GF: {
    name: 'French Guiana',
    region: 'Americas',
    timezones: {
      'America/Cayenne': '-03:00',
    },
    iso: {
      'alpha-2': 'GF',
      'alpha-3': 'GUF',
      numeric: '254',
    },
    phone: ['+594'],
    emoji: '\ud83c\uddec\ud83c\uddeb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg',
  },
  PF: {
    name: 'French Polynesia',
    region: 'Oceania',
    timezones: {
      'Pacific/Gambier': '-09:00',
      'Pacific/Marquesas': '-09:30',
      'Pacific/Tahiti': '-10:00',
    },
    iso: {
      'alpha-2': 'PF',
      'alpha-3': 'PYF',
      numeric: '258',
    },
    phone: ['+689'],
    emoji: '\ud83c\uddf5\ud83c\uddeb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg',
  },
  TF: {
    name: 'French Southern Territories',
    region: 'Africa',
    timezones: {
      'Indian/Kerguelen': '+05:00',
    },
    iso: {
      'alpha-2': 'TF',
      'alpha-3': 'ATF',
      numeric: '260',
    },
    phone: ['+262'],
    emoji: '\ud83c\uddf9\ud83c\uddeb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TF.svg',
  },
  GA: {
    name: 'Gabon',
    region: 'Africa',
    timezones: {
      'Africa/Libreville': '+01:00',
    },
    iso: {
      'alpha-2': 'GA',
      'alpha-3': 'GAB',
      numeric: '266',
    },
    phone: ['+241'],
    emoji: '\ud83c\uddec\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg',
  },
  GM: {
    name: 'Gambia',
    region: 'Africa',
    timezones: {
      'Africa/Banjul': '+00:00',
    },
    iso: {
      'alpha-2': 'GM',
      'alpha-3': 'GMB',
      numeric: '270',
    },
    phone: ['+220'],
    emoji: '\ud83c\uddec\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg',
  },
  GE: {
    name: 'Georgia',
    region: 'Asia',
    timezones: {
      'Asia/Tbilisi': '+04:00',
    },
    iso: {
      'alpha-2': 'GE',
      'alpha-3': 'GEO',
      numeric: '268',
    },
    phone: ['+995'],
    emoji: '\ud83c\uddec\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg',
  },
  DE: {
    name: 'Germany',
    region: 'Europe',
    timezones: {
      'Europe/Berlin': '+02:00',
      'Europe/Busingen': '+02:00',
    },
    iso: {
      'alpha-2': 'DE',
      'alpha-3': 'DEU',
      numeric: '276',
    },
    phone: ['+49'],
    emoji: '\ud83c\udde9\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg',
  },
  GH: {
    name: 'Ghana',
    region: 'Africa',
    timezones: {
      'Africa/Accra': '+00:00',
    },
    iso: {
      'alpha-2': 'GH',
      'alpha-3': 'GHA',
      numeric: '288',
    },
    phone: ['+233'],
    emoji: '\ud83c\uddec\ud83c\udded',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg',
  },
  GI: {
    name: 'Gibraltar',
    region: 'Europe',
    timezones: {
      'Europe/Gibraltar': '+02:00',
    },
    iso: {
      'alpha-2': 'GI',
      'alpha-3': 'GIB',
      numeric: '292',
    },
    phone: ['+350'],
    emoji: '\ud83c\uddec\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg',
  },
  GR: {
    name: 'Greece',
    region: 'Europe',
    timezones: {
      'Europe/Athens': '+03:00',
    },
    iso: {
      'alpha-2': 'GR',
      'alpha-3': 'GRC',
      numeric: '300',
    },
    phone: ['+30'],
    emoji: '\ud83c\uddec\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg',
  },
  GL: {
    name: 'Greenland',
    region: 'Americas',
    timezones: {
      'America/Danmarkshavn': '+00:00',
      'America/Nuuk': '-02:00',
      'America/Scoresbysund': '+00:00',
      'America/Thule': '-03:00',
    },
    iso: {
      'alpha-2': 'GL',
      'alpha-3': 'GRL',
      numeric: '304',
    },
    phone: ['+299'],
    emoji: '\ud83c\uddec\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg',
  },
  GD: {
    name: 'Grenada',
    region: 'Americas',
    timezones: {
      'America/Grenada': '-04:00',
    },
    iso: {
      'alpha-2': 'GD',
      'alpha-3': 'GRD',
      numeric: '308',
    },
    phone: ['+1-473'],
    emoji: '\ud83c\uddec\ud83c\udde9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg',
  },
  GP: {
    name: 'Guadeloupe',
    region: 'Americas',
    timezones: {
      'America/Guadeloupe': '-04:00',
    },
    iso: {
      'alpha-2': 'GP',
      'alpha-3': 'GLP',
      numeric: '312',
    },
    phone: ['+590'],
    emoji: '\ud83c\uddec\ud83c\uddf5',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg',
  },
  GU: {
    name: 'Guam',
    region: 'Oceania',
    timezones: {
      'Pacific/Guam': '+10:00',
    },
    iso: {
      'alpha-2': 'GU',
      'alpha-3': 'GUM',
      numeric: '316',
    },
    phone: ['+1-671'],
    emoji: '\ud83c\uddec\ud83c\uddfa',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg',
  },
  GT: {
    name: 'Guatemala',
    region: 'Americas',
    timezones: {
      'America/Guatemala': '-06:00',
    },
    iso: {
      'alpha-2': 'GT',
      'alpha-3': 'GTM',
      numeric: '320',
    },
    phone: ['+502'],
    emoji: '\ud83c\uddec\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg',
  },
  GG: {
    name: 'Guernsey',
    region: 'Europe',
    timezones: {
      'Europe/Guernsey': '+01:00',
    },
    iso: {
      'alpha-2': 'GG',
      'alpha-3': 'GGY',
      numeric: '831',
    },
    phone: ['+44-1481'],
    emoji: '\ud83c\uddec\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GG.svg',
  },
  GN: {
    name: 'Guinea',
    region: 'Africa',
    timezones: {
      'Africa/Conakry': '+00:00',
    },
    iso: {
      'alpha-2': 'GN',
      'alpha-3': 'GIN',
      numeric: '324',
    },
    phone: ['+224'],
    emoji: '\ud83c\uddec\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg',
  },
  GW: {
    name: 'Guinea-Bissau',
    region: 'Africa',
    timezones: {
      'Africa/Bissau': '+00:00',
    },
    iso: {
      'alpha-2': 'GW',
      'alpha-3': 'GNB',
      numeric: '624',
    },
    phone: ['+245'],
    emoji: '\ud83c\uddec\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg',
  },
  GY: {
    name: 'Guyana',
    region: 'Americas',
    timezones: {
      'America/Guyana': '-04:00',
    },
    iso: {
      'alpha-2': 'GY',
      'alpha-3': 'GUY',
      numeric: '328',
    },
    phone: ['+592'],
    emoji: '\ud83c\uddec\ud83c\uddfe',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg',
  },
  HT: {
    name: 'Haiti',
    region: 'Americas',
    timezones: {
      'America/Port-au-Prince': '-04:00',
    },
    iso: {
      'alpha-2': 'HT',
      'alpha-3': 'HTI',
      numeric: '332',
    },
    phone: ['+509'],
    emoji: '\ud83c\udded\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg',
  },
  VA: {
    name: 'Holy See (Vatican City State)',
    region: 'Europe',
    timezones: {
      'Europe/Vatican': '+02:00',
    },
    iso: {
      'alpha-2': 'VA',
      'alpha-3': 'VAT',
      numeric: '336',
    },
    phone: ['+379'],
    emoji: '\ud83c\uddfb\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VA.svg',
  },
  HN: {
    name: 'Honduras',
    region: 'Americas',
    timezones: {
      'America/Tegucigalpa': '-06:00',
    },
    iso: {
      'alpha-2': 'HN',
      'alpha-3': 'HND',
      numeric: '340',
    },
    phone: ['+504'],
    emoji: '\ud83c\udded\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg',
  },
  HK: {
    name: 'Hong Kong',
    region: 'Asia',
    timezones: {
      'Asia/Hong_Kong': '+08:00',
    },
    iso: {
      'alpha-2': 'HK',
      'alpha-3': 'HKG',
      numeric: '344',
    },
    phone: ['+852'],
    emoji: '\ud83c\udded\ud83c\uddf0',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HK.svg',
  },
  HU: {
    name: 'Hungary',
    region: 'Europe',
    timezones: {
      'Europe/Budapest': '+02:00',
    },
    iso: {
      'alpha-2': 'HU',
      'alpha-3': 'HUN',
      numeric: '348',
    },
    phone: ['+36'],
    emoji: '\ud83c\udded\ud83c\uddfa',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg',
  },
  IS: {
    name: 'Iceland',
    region: 'Europe',
    timezones: {
      'Atlantic/Reykjavik': '+00:00',
    },
    iso: {
      'alpha-2': 'IS',
      'alpha-3': 'ISL',
      numeric: '352',
    },
    phone: ['+354'],
    emoji: '\ud83c\uddee\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg',
  },
  IN: {
    name: 'India',
    region: 'Asia',
    timezones: {
      'Asia/Kolkata': '+05:30',
    },
    iso: {
      'alpha-2': 'IN',
      'alpha-3': 'IND',
      numeric: '356',
    },
    phone: ['+91'],
    emoji: '\ud83c\uddee\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg',
  },
  ID: {
    name: 'Indonesia',
    region: 'Asia',
    timezones: {
      'Asia/Jakarta': '+07:00',
      'Asia/Jayapura': '+09:00',
      'Asia/Makassar': '+08:00',
      'Asia/Pontianak': '+07:00',
    },
    iso: {
      'alpha-2': 'ID',
      'alpha-3': 'IDN',
      numeric: '360',
    },
    phone: ['+62'],
    emoji: '\ud83c\uddee\ud83c\udde9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg',
  },
  IR: {
    name: 'Iran, Islamic Republic of',
    region: 'Asia',
    timezones: {
      'Asia/Tehran': '+03:30',
    },
    iso: {
      'alpha-2': 'IR',
      'alpha-3': 'IRN',
      numeric: '364',
    },
    phone: ['+98'],
    emoji: '\ud83c\uddee\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IR.svg',
  },
  IQ: {
    name: 'Iraq',
    region: 'Asia',
    timezones: {
      'Asia/Baghdad': '+03:00',
    },
    iso: {
      'alpha-2': 'IQ',
      'alpha-3': 'IRQ',
      numeric: '368',
    },
    phone: ['+964'],
    emoji: '\ud83c\uddee\ud83c\uddf6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg',
  },
  IE: {
    name: 'Ireland',
    region: 'Europe',
    timezones: {
      'Europe/Dublin': '+01:00',
    },
    iso: {
      'alpha-2': 'IE',
      'alpha-3': 'IRL',
      numeric: '372',
    },
    phone: ['+353'],
    emoji: '\ud83c\uddee\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg',
  },
  IM: {
    name: 'Isle of Man',
    region: 'Europe',
    timezones: {
      'Europe/Isle_of_Man': '+01:00',
    },
    iso: {
      'alpha-2': 'IM',
      'alpha-3': 'IMN',
      numeric: '833',
    },
    phone: ['+44-1624'],
    emoji: '\ud83c\uddee\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IM.svg',
  },
  IL: {
    name: 'Israel',
    region: 'Asia',
    timezones: {
      'Asia/Jerusalem': '+03:00',
    },
    iso: {
      'alpha-2': 'IL',
      'alpha-3': 'ISR',
      numeric: '376',
    },
    phone: ['+972'],
    emoji: '\ud83c\uddee\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg',
  },
  IT: {
    name: 'Italy',
    region: 'Europe',
    timezones: {
      'Europe/Rome': '+02:00',
    },
    iso: {
      'alpha-2': 'IT',
      'alpha-3': 'ITA',
      numeric: '380',
    },
    phone: ['+39'],
    emoji: '\ud83c\uddee\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg',
  },
  JM: {
    name: 'Jamaica',
    region: 'Americas',
    timezones: {
      'America/Jamaica': '-05:00',
    },
    iso: {
      'alpha-2': 'JM',
      'alpha-3': 'JAM',
      numeric: '388',
    },
    phone: ['+1-876'],
    emoji: '\ud83c\uddef\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg',
  },
  JP: {
    name: 'Japan',
    region: 'Asia',
    timezones: {
      'Asia/Tokyo': '+09:00',
    },
    iso: {
      'alpha-2': 'JP',
      'alpha-3': 'JPN',
      numeric: '392',
    },
    phone: ['+81'],
    emoji: '\ud83c\uddef\ud83c\uddf5',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg',
  },
  JE: {
    name: 'Jersey',
    region: 'Europe',
    timezones: {
      'Europe/Jersey': '+01:00',
    },
    iso: {
      'alpha-2': 'JE',
      'alpha-3': 'JEY',
      numeric: '832',
    },
    phone: ['+44-1534'],
    emoji: '\ud83c\uddef\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JE.svg',
  },
  JO: {
    name: 'Jordan',
    region: 'Asia',
    timezones: {
      'Asia/Amman': '+03:00',
    },
    iso: {
      'alpha-2': 'JO',
      'alpha-3': 'JOR',
      numeric: '400',
    },
    phone: ['+962'],
    emoji: '\ud83c\uddef\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg',
  },
  KZ: {
    name: 'Kazakhstan',
    region: 'Asia',
    timezones: {
      'Asia/Almaty': '+06:00',
      'Asia/Aqtau': '+05:00',
      'Asia/Aqtobe': '+05:00',
      'Asia/Atyrau': '+05:00',
      'Asia/Oral': '+05:00',
      'Asia/Qostanay': '+06:00',
      'Asia/Qyzylorda': '+05:00',
    },
    iso: {
      'alpha-2': 'KZ',
      'alpha-3': 'KAZ',
      numeric: '398',
    },
    phone: ['+7'],
    emoji: '\ud83c\uddf0\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg',
  },
  KE: {
    name: 'Kenya',
    region: 'Africa',
    timezones: {
      'Africa/Nairobi': '+03:00',
    },
    iso: {
      'alpha-2': 'KE',
      'alpha-3': 'KEN',
      numeric: '404',
    },
    phone: ['+254'],
    emoji: '\ud83c\uddf0\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg',
  },
  KI: {
    name: 'Kiribati',
    region: 'Oceania',
    timezones: {
      'Pacific/Kanton': '+13:00',
      'Pacific/Kiritimati': '+14:00',
      'Pacific/Tarawa': '+12:00',
    },
    iso: {
      'alpha-2': 'KI',
      'alpha-3': 'KIR',
      numeric: '296',
    },
    phone: ['+686'],
    emoji: '\ud83c\uddf0\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg',
  },
  KP: {
    name: "Korea, Democratic People's Republic of",
    region: 'Asia',
    timezones: {
      'Asia/Pyongyang': '+09:00',
    },
    iso: {
      'alpha-2': 'KP',
      'alpha-3': 'PRK',
      numeric: '408',
    },
    phone: ['+850'],
    emoji: '\ud83c\uddf0\ud83c\uddf5',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KP.svg',
  },
  KR: {
    name: 'Korea, Republic of',
    region: 'Asia',
    timezones: {
      'Asia/Seoul': '+09:00',
    },
    iso: {
      'alpha-2': 'KR',
      'alpha-3': 'KOR',
      numeric: '410',
    },
    phone: ['+82'],
    emoji: '\ud83c\uddf0\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KR.svg',
  },
  KW: {
    name: 'Kuwait',
    region: 'Asia',
    timezones: {
      'Asia/Kuwait': '+03:00',
    },
    iso: {
      'alpha-2': 'KW',
      'alpha-3': 'KWT',
      numeric: '414',
    },
    phone: ['+965'],
    emoji: '\ud83c\uddf0\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg',
  },
  KG: {
    name: 'Kyrgyzstan',
    region: 'Asia',
    timezones: {
      'Asia/Bishkek': '+06:00',
    },
    iso: {
      'alpha-2': 'KG',
      'alpha-3': 'KGZ',
      numeric: '417',
    },
    phone: ['+996'],
    emoji: '\ud83c\uddf0\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg',
  },
  LA: {
    name: "Lao People's Democratic Republic",
    region: 'Asia',
    timezones: {
      'Asia/Vientiane': '+07:00',
    },
    iso: {
      'alpha-2': 'LA',
      'alpha-3': 'LAO',
      numeric: '418',
    },
    phone: ['+856'],
    emoji: '\ud83c\uddf1\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg',
  },
  LV: {
    name: 'Latvia',
    region: 'Europe',
    timezones: {
      'Europe/Riga': '+03:00',
    },
    iso: {
      'alpha-2': 'LV',
      'alpha-3': 'LVA',
      numeric: '428',
    },
    phone: ['+371'],
    emoji: '\ud83c\uddf1\ud83c\uddfb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg',
  },
  LB: {
    name: 'Lebanon',
    region: 'Asia',
    timezones: {
      'Asia/Beirut': '+03:00',
    },
    iso: {
      'alpha-2': 'LB',
      'alpha-3': 'LBN',
      numeric: '422',
    },
    phone: ['+961'],
    emoji: '\ud83c\uddf1\ud83c\udde7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg',
  },
  LS: {
    name: 'Lesotho',
    region: 'Africa',
    timezones: {
      'Africa/Maseru': '+02:00',
    },
    iso: {
      'alpha-2': 'LS',
      'alpha-3': 'LSO',
      numeric: '426',
    },
    phone: ['+266'],
    emoji: '\ud83c\uddf1\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg',
  },
  LR: {
    name: 'Liberia',
    region: 'Africa',
    timezones: {
      'Africa/Monrovia': '+00:00',
    },
    iso: {
      'alpha-2': 'LR',
      'alpha-3': 'LBR',
      numeric: '430',
    },
    phone: ['+231'],
    emoji: '\ud83c\uddf1\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg',
  },
  LY: {
    name: 'Libya',
    region: 'Africa',
    timezones: {
      'Africa/Tripoli': '+02:00',
    },
    iso: {
      'alpha-2': 'LY',
      'alpha-3': 'LBY',
      numeric: '434',
    },
    phone: ['+218'],
    emoji: '\ud83c\uddf1\ud83c\uddfe',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LY.svg',
  },
  LI: {
    name: 'Liechtenstein',
    region: 'Europe',
    timezones: {
      'Europe/Vaduz': '+02:00',
    },
    iso: {
      'alpha-2': 'LI',
      'alpha-3': 'LIE',
      numeric: '438',
    },
    phone: ['+423'],
    emoji: '\ud83c\uddf1\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg',
  },
  LT: {
    name: 'Lithuania',
    region: 'Europe',
    timezones: {
      'Europe/Vilnius': '+03:00',
    },
    iso: {
      'alpha-2': 'LT',
      'alpha-3': 'LTU',
      numeric: '440',
    },
    phone: ['+370'],
    emoji: '\ud83c\uddf1\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg',
  },
  LU: {
    name: 'Luxembourg',
    region: 'Europe',
    timezones: {
      'Europe/Luxembourg': '+02:00',
    },
    iso: {
      'alpha-2': 'LU',
      'alpha-3': 'LUX',
      numeric: '442',
    },
    phone: ['+352'],
    emoji: '\ud83c\uddf1\ud83c\uddfa',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg',
  },
  MO: {
    name: 'Macao',
    region: 'Asia',
    timezones: {
      'Asia/Macau': '+08:00',
    },
    iso: {
      'alpha-2': 'MO',
      'alpha-3': 'MAC',
      numeric: '446',
    },
    phone: ['+853'],
    emoji: '\ud83c\uddf2\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MO.svg',
  },
  MK: {
    name: 'Macedonia, the Former Yugoslav Republic of',
    region: 'Europe',
    timezones: {
      'Europe/Skopje': '+02:00',
    },
    iso: {
      'alpha-2': 'MK',
      'alpha-3': 'MKD',
      numeric: '807',
    },
    phone: ['+389'],
    emoji: '\ud83c\uddf2\ud83c\uddf0',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MK.svg',
  },
  MG: {
    name: 'Madagascar',
    region: 'Africa',
    timezones: {
      'Indian/Antananarivo': '+03:00',
    },
    iso: {
      'alpha-2': 'MG',
      'alpha-3': 'MDG',
      numeric: '450',
    },
    phone: ['+261'],
    emoji: '\ud83c\uddf2\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg',
  },
  MW: {
    name: 'Malawi',
    region: 'Africa',
    timezones: {
      'Africa/Blantyre': '+02:00',
    },
    iso: {
      'alpha-2': 'MW',
      'alpha-3': 'MWI',
      numeric: '454',
    },
    phone: ['+265'],
    emoji: '\ud83c\uddf2\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg',
  },
  MY: {
    name: 'Malaysia',
    region: 'Asia',
    timezones: {
      'Asia/Kuala_Lumpur': '+08:00',
      'Asia/Kuching': '+08:00',
    },
    iso: {
      'alpha-2': 'MY',
      'alpha-3': 'MYS',
      numeric: '458',
    },
    phone: ['+60'],
    emoji: '\ud83c\uddf2\ud83c\uddfe',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg',
  },
  MV: {
    name: 'Maldives',
    region: 'Asia',
    timezones: {
      'Indian/Maldives': '+05:00',
    },
    iso: {
      'alpha-2': 'MV',
      'alpha-3': 'MDV',
      numeric: '462',
    },
    phone: ['+960'],
    emoji: '\ud83c\uddf2\ud83c\uddfb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg',
  },
  ML: {
    name: 'Mali',
    region: 'Africa',
    timezones: {
      'Africa/Bamako': '+00:00',
    },
    iso: {
      'alpha-2': 'ML',
      'alpha-3': 'MLI',
      numeric: '466',
    },
    phone: ['+223'],
    emoji: '\ud83c\uddf2\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg',
  },
  MT: {
    name: 'Malta',
    region: 'Europe',
    timezones: {
      'Europe/Malta': '+02:00',
    },
    iso: {
      'alpha-2': 'MT',
      'alpha-3': 'MLT',
      numeric: '470',
    },
    phone: ['+356'],
    emoji: '\ud83c\uddf2\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg',
  },
  MH: {
    name: 'Marshall Islands',
    region: 'Oceania',
    timezones: {
      'Pacific/Kwajalein': '+12:00',
      'Pacific/Majuro': '+12:00',
    },
    iso: {
      'alpha-2': 'MH',
      'alpha-3': 'MHL',
      numeric: '584',
    },
    phone: ['+692'],
    emoji: '\ud83c\uddf2\ud83c\udded',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg',
  },
  MQ: {
    name: 'Martinique',
    region: 'Americas',
    timezones: {
      'America/Martinique': '-04:00',
    },
    iso: {
      'alpha-2': 'MQ',
      'alpha-3': 'MTQ',
      numeric: '474',
    },
    phone: ['+596'],
    emoji: '\ud83c\uddf2\ud83c\uddf6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg',
  },
  MR: {
    name: 'Mauritania',
    region: 'Africa',
    timezones: {
      'Africa/Nouakchott': '+00:00',
    },
    iso: {
      'alpha-2': 'MR',
      'alpha-3': 'MRT',
      numeric: '478',
    },
    phone: ['+222'],
    emoji: '\ud83c\uddf2\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg',
  },
  MU: {
    name: 'Mauritius',
    region: 'Africa',
    timezones: {
      'Indian/Mauritius': '+04:00',
    },
    iso: {
      'alpha-2': 'MU',
      'alpha-3': 'MUS',
      numeric: '480',
    },
    phone: ['+230'],
    emoji: '\ud83c\uddf2\ud83c\uddfa',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg',
  },
  YT: {
    name: 'Mayotte',
    region: 'Africa',
    timezones: {
      'Indian/Mayotte': '+03:00',
    },
    iso: {
      'alpha-2': 'YT',
      'alpha-3': 'MYT',
      numeric: '175',
    },
    phone: ['+262'],
    emoji: '\ud83c\uddfe\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg',
  },
  MX: {
    name: 'Mexico',
    region: 'Americas',
    timezones: {
      'America/Bahia_Banderas': '-06:00',
      'America/Cancun': '-05:00',
      'America/Chihuahua': '-06:00',
      'America/Ciudad_Juarez': '-06:00',
      'America/Hermosillo': '-07:00',
      'America/Matamoros': '-05:00',
      'America/Mazatlan': '-07:00',
      'America/Merida': '-06:00',
      'America/Mexico_City': '-06:00',
      'America/Monterrey': '-06:00',
      'America/Ojinaga': '-05:00',
      'America/Tijuana': '-07:00',
    },
    iso: {
      'alpha-2': 'MX',
      'alpha-3': 'MEX',
      numeric: '484',
    },
    phone: ['+52'],
    emoji: '\ud83c\uddf2\ud83c\uddfd',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg',
  },
  FM: {
    name: 'Micronesia, Federated States of',
    region: 'Oceania',
    timezones: {
      'Pacific/Chuuk': '+10:00',
      'Pacific/Kosrae': '+11:00',
      'Pacific/Pohnpei': '+11:00',
    },
    iso: {
      'alpha-2': 'FM',
      'alpha-3': 'FSM',
      numeric: '583',
    },
    phone: ['+691'],
    emoji: '\ud83c\uddeb\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FM.svg',
  },
  MD: {
    name: 'Moldova, Republic of',
    region: 'Europe',
    timezones: {
      'Europe/Chisinau': '+03:00',
    },
    iso: {
      'alpha-2': 'MD',
      'alpha-3': 'MDA',
      numeric: '498',
    },
    phone: ['+373'],
    emoji: '\ud83c\uddf2\ud83c\udde9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg',
  },
  MC: {
    name: 'Monaco',
    region: 'Europe',
    timezones: {
      'Europe/Monaco': '+02:00',
    },
    iso: {
      'alpha-2': 'MC',
      'alpha-3': 'MCO',
      numeric: '492',
    },
    phone: ['+377'],
    emoji: '\ud83c\uddf2\ud83c\udde8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg',
  },
  MN: {
    name: 'Mongolia',
    region: 'Asia',
    timezones: {
      'Asia/Choibalsan': '+08:00',
      'Asia/Hovd': '+07:00',
      'Asia/Ulaanbaatar': '+08:00',
    },
    iso: {
      'alpha-2': 'MN',
      'alpha-3': 'MNG',
      numeric: '496',
    },
    phone: ['+976'],
    emoji: '\ud83c\uddf2\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg',
  },
  ME: {
    name: 'Montenegro',
    region: 'Europe',
    timezones: {
      'Europe/Podgorica': '+02:00',
    },
    iso: {
      'alpha-2': 'ME',
      'alpha-3': 'MNE',
      numeric: '499',
    },
    phone: ['+382'],
    emoji: '\ud83c\uddf2\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg',
  },
  MS: {
    name: 'Montserrat',
    region: 'Americas',
    timezones: {
      'America/Montserrat': '-04:00',
    },
    iso: {
      'alpha-2': 'MS',
      'alpha-3': 'MSR',
      numeric: '500',
    },
    phone: ['+1-664'],
    emoji: '\ud83c\uddf2\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MS.svg',
  },
  MA: {
    name: 'Morocco',
    region: 'Africa',
    timezones: {
      'Africa/Casablanca': '+00:00',
      'Africa/El_Aaiun': '+00:00',
    },
    iso: {
      'alpha-2': 'MA',
      'alpha-3': 'MAR',
      numeric: '504',
    },
    phone: ['+212'],
    emoji: '\ud83c\uddf2\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg',
  },
  MZ: {
    name: 'Mozambique',
    region: 'Africa',
    timezones: {
      'Africa/Maputo': '+02:00',
    },
    iso: {
      'alpha-2': 'MZ',
      'alpha-3': 'MOZ',
      numeric: '508',
    },
    phone: ['+258'],
    emoji: '\ud83c\uddf2\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MZ.svg',
  },
  MM: {
    name: 'Myanmar',
    region: 'Asia',
    timezones: {
      'Asia/Yangon': '+06:30',
    },
    iso: {
      'alpha-2': 'MM',
      'alpha-3': 'MMR',
      numeric: '104',
    },
    phone: ['+95'],
    emoji: '\ud83c\uddf2\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MM.svg',
  },
  NA: {
    name: 'Namibia',
    region: 'Africa',
    timezones: {
      'Africa/Windhoek': '+02:00',
    },
    iso: {
      'alpha-2': 'NA',
      'alpha-3': 'NAM',
      numeric: '516',
    },
    phone: ['+264'],
    emoji: '\ud83c\uddf3\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg',
  },
  NR: {
    name: 'Nauru',
    region: 'Oceania',
    timezones: {
      'Pacific/Nauru': '+12:00',
    },
    iso: {
      'alpha-2': 'NR',
      'alpha-3': 'NRU',
      numeric: '520',
    },
    phone: ['+674'],
    emoji: '\ud83c\uddf3\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg',
  },
  NP: {
    name: 'Nepal',
    region: 'Asia',
    timezones: {
      'Asia/Kathmandu': '+05:45',
    },
    iso: {
      'alpha-2': 'NP',
      'alpha-3': 'NPL',
      numeric: '524',
    },
    phone: ['+977'],
    emoji: '\ud83c\uddf3\ud83c\uddf5',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg',
  },
  NL: {
    name: 'Netherlands',
    region: 'Europe',
    timezones: {
      'Europe/Amsterdam': '+02:00',
    },
    iso: {
      'alpha-2': 'NL',
      'alpha-3': 'NLD',
      numeric: '528',
    },
    phone: ['+31'],
    emoji: '\ud83c\uddf3\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg',
  },
  NC: {
    name: 'New Caledonia',
    region: 'Oceania',
    timezones: {
      'Pacific/Noumea': '+11:00',
    },
    iso: {
      'alpha-2': 'NC',
      'alpha-3': 'NCL',
      numeric: '540',
    },
    phone: ['+687'],
    emoji: '\ud83c\uddf3\ud83c\udde8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg',
  },
  NZ: {
    name: 'New Zealand',
    region: 'Oceania',
    timezones: {
      'Pacific/Auckland': '+12:00',
      'Pacific/Chatham': '+12:45',
    },
    iso: {
      'alpha-2': 'NZ',
      'alpha-3': 'NZL',
      numeric: '554',
    },
    phone: ['+64'],
    emoji: '\ud83c\uddf3\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg',
  },
  NI: {
    name: 'Nicaragua',
    region: 'Americas',
    timezones: {
      'America/Managua': '-06:00',
    },
    iso: {
      'alpha-2': 'NI',
      'alpha-3': 'NIC',
      numeric: '558',
    },
    phone: ['+505'],
    emoji: '\ud83c\uddf3\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg',
  },
  NE: {
    name: 'Niger',
    region: 'Africa',
    timezones: {
      'Africa/Niamey': '+01:00',
    },
    iso: {
      'alpha-2': 'NE',
      'alpha-3': 'NER',
      numeric: '562',
    },
    phone: ['+227'],
    emoji: '\ud83c\uddf3\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg',
  },
  NG: {
    name: 'Nigeria',
    region: 'Africa',
    timezones: {
      'Africa/Lagos': '+01:00',
    },
    iso: {
      'alpha-2': 'NG',
      'alpha-3': 'NGA',
      numeric: '566',
    },
    phone: ['+234'],
    emoji: '\ud83c\uddf3\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg',
  },
  NU: {
    name: 'Niue',
    region: 'Oceania',
    timezones: {
      'Pacific/Niue': '-11:00',
    },
    iso: {
      'alpha-2': 'NU',
      'alpha-3': 'NIU',
      numeric: '570',
    },
    phone: ['+683'],
    emoji: '\ud83c\uddf3\ud83c\uddfa',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg',
  },
  NF: {
    name: 'Norfolk Island',
    region: 'Oceania',
    timezones: {
      'Pacific/Norfolk': '+11:00',
    },
    iso: {
      'alpha-2': 'NF',
      'alpha-3': 'NFK',
      numeric: '574',
    },
    phone: ['+672'],
    emoji: '\ud83c\uddf3\ud83c\uddeb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg',
  },
  MP: {
    name: 'Northern Mariana Islands',
    region: 'Oceania',
    timezones: {
      'Pacific/Saipan': '+10:00',
    },
    iso: {
      'alpha-2': 'MP',
      'alpha-3': 'MNP',
      numeric: '580',
    },
    phone: ['+1-670'],
    emoji: '\ud83c\uddf2\ud83c\uddf5',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg',
  },
  NO: {
    name: 'Norway',
    region: 'Europe',
    timezones: {
      'Europe/Oslo': '+02:00',
    },
    iso: {
      'alpha-2': 'NO',
      'alpha-3': 'NOR',
      numeric: '578',
    },
    phone: ['+47'],
    emoji: '\ud83c\uddf3\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg',
  },
  OM: {
    name: 'Oman',
    region: 'Asia',
    timezones: {
      'Asia/Muscat': '+04:00',
    },
    iso: {
      'alpha-2': 'OM',
      'alpha-3': 'OMN',
      numeric: '512',
    },
    phone: ['+968'],
    emoji: '\ud83c\uddf4\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg',
  },
  PK: {
    name: 'Pakistan',
    region: 'Asia',
    timezones: {
      'Asia/Karachi': '+05:00',
    },
    iso: {
      'alpha-2': 'PK',
      'alpha-3': 'PAK',
      numeric: '586',
    },
    phone: ['+92'],
    emoji: '\ud83c\uddf5\ud83c\uddf0',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg',
  },
  PW: {
    name: 'Palau',
    region: 'Oceania',
    timezones: {
      'Pacific/Palau': '+09:00',
    },
    iso: {
      'alpha-2': 'PW',
      'alpha-3': 'PLW',
      numeric: '585',
    },
    phone: ['+680'],
    emoji: '\ud83c\uddf5\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg',
  },
  PS: {
    name: 'Palestine, State of',
    region: 'Asia',
    timezones: {
      'Asia/Gaza': '+02:00',
      'Asia/Hebron': '+02:00',
    },
    iso: {
      'alpha-2': 'PS',
      'alpha-3': 'PSE',
      numeric: '275',
    },
    phone: ['+970'],
    emoji: '\ud83c\uddf5\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PS.svg',
  },
  PA: {
    name: 'Panama',
    region: 'Americas',
    timezones: {
      'America/Panama': '-05:00',
    },
    iso: {
      'alpha-2': 'PA',
      'alpha-3': 'PAN',
      numeric: '591',
    },
    phone: ['+507'],
    emoji: '\ud83c\uddf5\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg',
  },
  PG: {
    name: 'Papua New Guinea',
    region: 'Oceania',
    timezones: {
      'Pacific/Bougainville': '+11:00',
      'Pacific/Port_Moresby': '+10:00',
    },
    iso: {
      'alpha-2': 'PG',
      'alpha-3': 'PNG',
      numeric: '598',
    },
    phone: ['+675'],
    emoji: '\ud83c\uddf5\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg',
  },
  PY: {
    name: 'Paraguay',
    region: 'Americas',
    timezones: {
      'America/Asuncion': '-04:00',
    },
    iso: {
      'alpha-2': 'PY',
      'alpha-3': 'PRY',
      numeric: '600',
    },
    phone: ['+595'],
    emoji: '\ud83c\uddf5\ud83c\uddfe',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg',
  },
  PE: {
    name: 'Peru',
    region: 'Americas',
    timezones: {
      'America/Lima': '-05:00',
    },
    iso: {
      'alpha-2': 'PE',
      'alpha-3': 'PER',
      numeric: '604',
    },
    phone: ['+51'],
    emoji: '\ud83c\uddf5\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg',
  },
  PH: {
    name: 'Philippines',
    region: 'Asia',
    timezones: {
      'Asia/Manila': '+08:00',
    },
    iso: {
      'alpha-2': 'PH',
      'alpha-3': 'PHL',
      numeric: '608',
    },
    phone: ['+63'],
    emoji: '\ud83c\uddf5\ud83c\udded',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg',
  },
  PN: {
    name: 'Pitcairn',
    region: 'Oceania',
    timezones: {
      'Pacific/Pitcairn': '-08:00',
    },
    iso: {
      'alpha-2': 'PN',
      'alpha-3': 'PCN',
      numeric: '612',
    },
    phone: ['+870'],
    emoji: '\ud83c\uddf5\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PN.svg',
  },
  PL: {
    name: 'Poland',
    region: 'Europe',
    timezones: {
      'Europe/Warsaw': '+02:00',
    },
    iso: {
      'alpha-2': 'PL',
      'alpha-3': 'POL',
      numeric: '616',
    },
    phone: ['+48'],
    emoji: '\ud83c\uddf5\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg',
  },
  PT: {
    name: 'Portugal',
    region: 'Europe',
    timezones: {
      'Atlantic/Azores': '+00:00',
      'Atlantic/Madeira': '+01:00',
      'Europe/Lisbon': '+01:00',
    },
    iso: {
      'alpha-2': 'PT',
      'alpha-3': 'PRT',
      numeric: '620',
    },
    phone: ['+351'],
    emoji: '\ud83c\uddf5\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg',
  },
  PR: {
    name: 'Puerto Rico',
    region: 'Americas',
    timezones: {
      'America/Puerto_Rico': '-04:00',
    },
    iso: {
      'alpha-2': 'PR',
      'alpha-3': 'PRI',
      numeric: '630',
    },
    phone: ['+1-787', '+1-939'],
    emoji: '\ud83c\uddf5\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg',
  },
  QA: {
    name: 'Qatar',
    region: 'Asia',
    timezones: {
      'Asia/Qatar': '+03:00',
    },
    iso: {
      'alpha-2': 'QA',
      'alpha-3': 'QAT',
      numeric: '634',
    },
    phone: ['+974'],
    emoji: '\ud83c\uddf6\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg',
  },
  RO: {
    name: 'Romania',
    region: 'Europe',
    timezones: {
      'Europe/Bucharest': '+03:00',
    },
    iso: {
      'alpha-2': 'RO',
      'alpha-3': 'ROU',
      numeric: '642',
    },
    phone: ['+40'],
    emoji: '\ud83c\uddf7\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg',
  },
  RU: {
    name: 'Russian Federation',
    region: 'Europe',
    timezones: {
      'Asia/Anadyr': '+12:00',
      'Asia/Barnaul': '+07:00',
      'Asia/Chita': '+09:00',
      'Asia/Irkutsk': '+08:00',
      'Asia/Kamchatka': '+12:00',
      'Asia/Khandyga': '+09:00',
      'Asia/Krasnoyarsk': '+07:00',
      'Asia/Magadan': '+11:00',
      'Asia/Novokuznetsk': '+07:00',
      'Asia/Novosibirsk': '+07:00',
      'Asia/Omsk': '+06:00',
      'Asia/Sakhalin': '+11:00',
      'Asia/Srednekolymsk': '+11:00',
      'Asia/Tomsk': '+07:00',
      'Asia/Ust-Nera': '+10:00',
      'Asia/Vladivostok': '+10:00',
      'Asia/Yakutsk': '+09:00',
      'Asia/Yekaterinburg': '+05:00',
      'Europe/Astrakhan': '+04:00',
      'Europe/Kaliningrad': '+02:00',
      'Europe/Kirov': '+03:00',
      'Europe/Moscow': '+03:00',
      'Europe/Samara': '+04:00',
      'Europe/Saratov': '+04:00',
      'Europe/Ulyanovsk': '+04:00',
      'Europe/Volgograd': '+03:00',
    },
    iso: {
      'alpha-2': 'RU',
      'alpha-3': 'RUS',
      numeric: '643',
    },
    phone: ['+7'],
    emoji: '\ud83c\uddf7\ud83c\uddfa',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg',
  },
  RW: {
    name: 'Rwanda',
    region: 'Africa',
    timezones: {
      'Africa/Kigali': '+02:00',
    },
    iso: {
      'alpha-2': 'RW',
      'alpha-3': 'RWA',
      numeric: '646',
    },
    phone: ['+250'],
    emoji: '\ud83c\uddf7\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg',
  },
  RE: {
    name: 'R\u00e9union',
    region: 'Africa',
    timezones: {
      'Indian/Reunion': '+04:00',
    },
    iso: {
      'alpha-2': 'RE',
      'alpha-3': 'REU',
      numeric: '638',
    },
    phone: ['+262'],
    emoji: '\ud83c\uddf7\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RE.svg',
  },
  BL: {
    name: 'Saint Barth\u00e9lemy',
    region: 'Americas',
    timezones: {
      'America/St_Barthelemy': '-04:00',
    },
    iso: {
      'alpha-2': 'BL',
      'alpha-3': 'BLM',
      numeric: '652',
    },
    phone: ['+590'],
    emoji: '\ud83c\udde7\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BL.svg',
  },
  SH: {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    region: 'Africa',
    timezones: {
      'Atlantic/St_Helena': '+00:00',
    },
    iso: {
      'alpha-2': 'SH',
      'alpha-3': 'SHN',
      numeric: '654',
    },
    phone: ['+290'],
    emoji: '\ud83c\uddf8\ud83c\udded',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SH.svg',
  },
  KN: {
    name: 'Saint Kitts and Nevis',
    region: 'Americas',
    timezones: {
      'America/St_Kitts': '-04:00',
    },
    iso: {
      'alpha-2': 'KN',
      'alpha-3': 'KNA',
      numeric: '659',
    },
    phone: ['+1-869'],
    emoji: '\ud83c\uddf0\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KN.svg',
  },
  LC: {
    name: 'Saint Lucia',
    region: 'Americas',
    timezones: {
      'America/St_Lucia': '-04:00',
    },
    iso: {
      'alpha-2': 'LC',
      'alpha-3': 'LCA',
      numeric: '662',
    },
    phone: ['+1-758'],
    emoji: '\ud83c\uddf1\ud83c\udde8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LC.svg',
  },
  MF: {
    name: 'Saint Martin (French part)',
    region: 'Americas',
    timezones: {
      'America/Marigot': '-04:00',
    },
    iso: {
      'alpha-2': 'MF',
      'alpha-3': 'MAF',
      numeric: '663',
    },
    phone: ['+590'],
    emoji: '\ud83c\uddf2\ud83c\uddeb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MF.svg',
  },
  PM: {
    name: 'Saint Pierre and Miquelon',
    region: 'Americas',
    timezones: {
      'America/Miquelon': '-02:00',
    },
    iso: {
      'alpha-2': 'PM',
      'alpha-3': 'SPM',
      numeric: '666',
    },
    phone: ['+508'],
    emoji: '\ud83c\uddf5\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PM.svg',
  },
  VC: {
    name: 'Saint Vincent and the Grenadines',
    region: 'Americas',
    timezones: {
      'America/St_Vincent': '-04:00',
    },
    iso: {
      'alpha-2': 'VC',
      'alpha-3': 'VCT',
      numeric: '670',
    },
    phone: ['+1-784'],
    emoji: '\ud83c\uddfb\ud83c\udde8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VC.svg',
  },
  WS: {
    name: 'Samoa',
    region: 'Oceania',
    timezones: {
      'Pacific/Apia': '+13:00',
    },
    iso: {
      'alpha-2': 'WS',
      'alpha-3': 'WSM',
      numeric: '882',
    },
    phone: ['+685'],
    emoji: '\ud83c\uddfc\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg',
  },
  SM: {
    name: 'San Marino',
    region: 'Europe',
    timezones: {
      'Europe/San_Marino': '+02:00',
    },
    iso: {
      'alpha-2': 'SM',
      'alpha-3': 'SMR',
      numeric: '674',
    },
    phone: ['+378'],
    emoji: '\ud83c\uddf8\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg',
  },
  ST: {
    name: 'Sao Tome and Principe',
    region: 'Africa',
    timezones: {
      'Africa/Sao_Tome': '+00:00',
    },
    iso: {
      'alpha-2': 'ST',
      'alpha-3': 'STP',
      numeric: '678',
    },
    phone: ['+239'],
    emoji: '\ud83c\uddf8\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ST.svg',
  },
  SA: {
    name: 'Saudi Arabia',
    region: 'Asia',
    timezones: {
      'Asia/Riyadh': '+03:00',
    },
    iso: {
      'alpha-2': 'SA',
      'alpha-3': 'SAU',
      numeric: '682',
    },
    phone: ['+966'],
    emoji: '\ud83c\uddf8\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg',
  },
  SN: {
    name: 'Senegal',
    region: 'Africa',
    timezones: {
      'Africa/Dakar': '+00:00',
    },
    iso: {
      'alpha-2': 'SN',
      'alpha-3': 'SEN',
      numeric: '686',
    },
    phone: ['+221'],
    emoji: '\ud83c\uddf8\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg',
  },
  RS: {
    name: 'Serbia',
    region: 'Europe',
    timezones: {
      'Europe/Belgrade': '+02:00',
    },
    iso: {
      'alpha-2': 'RS',
      'alpha-3': 'SRB',
      numeric: '688',
    },
    phone: ['+381'],
    emoji: '\ud83c\uddf7\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg',
  },
  SC: {
    name: 'Seychelles',
    region: 'Africa',
    timezones: {
      'Indian/Mahe': '+04:00',
    },
    iso: {
      'alpha-2': 'SC',
      'alpha-3': 'SYC',
      numeric: '690',
    },
    phone: ['+248'],
    emoji: '\ud83c\uddf8\ud83c\udde8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg',
  },
  SL: {
    name: 'Sierra Leone',
    region: 'Africa',
    timezones: {
      'Africa/Freetown': '+00:00',
    },
    iso: {
      'alpha-2': 'SL',
      'alpha-3': 'SLE',
      numeric: '694',
    },
    phone: ['+232'],
    emoji: '\ud83c\uddf8\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg',
  },
  SG: {
    name: 'Singapore',
    region: 'Asia',
    timezones: {
      'Asia/Singapore': '+08:00',
    },
    iso: {
      'alpha-2': 'SG',
      'alpha-3': 'SGP',
      numeric: '702',
    },
    phone: ['+65'],
    emoji: '\ud83c\uddf8\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg',
  },
  SX: {
    name: 'Sint Maarten (Dutch part)',
    region: 'Americas',
    timezones: {
      'America/Lower_Princes': '-04:00',
    },
    iso: {
      'alpha-2': 'SX',
      'alpha-3': 'SXM',
      numeric: '534',
    },
    phone: ['+599'],
    emoji: '\ud83c\uddf8\ud83c\uddfd',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SX.svg',
  },
  SK: {
    name: 'Slovakia',
    region: 'Europe',
    timezones: {
      'Europe/Bratislava': '+02:00',
    },
    iso: {
      'alpha-2': 'SK',
      'alpha-3': 'SVK',
      numeric: '703',
    },
    phone: ['+421'],
    emoji: '\ud83c\uddf8\ud83c\uddf0',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg',
  },
  SI: {
    name: 'Slovenia',
    region: 'Europe',
    timezones: {
      'Europe/Ljubljana': '+02:00',
    },
    iso: {
      'alpha-2': 'SI',
      'alpha-3': 'SVN',
      numeric: '705',
    },
    phone: ['+386'],
    emoji: '\ud83c\uddf8\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg',
  },
  SB: {
    name: 'Solomon Islands',
    region: 'Oceania',
    timezones: {
      'Pacific/Guadalcanal': '+11:00',
    },
    iso: {
      'alpha-2': 'SB',
      'alpha-3': 'SLB',
      numeric: '090',
    },
    phone: ['+677'],
    emoji: '\ud83c\uddf8\ud83c\udde7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg',
  },
  SO: {
    name: 'Somalia',
    region: 'Africa',
    timezones: {
      'Africa/Mogadishu': '+03:00',
    },
    iso: {
      'alpha-2': 'SO',
      'alpha-3': 'SOM',
      numeric: '706',
    },
    phone: ['+252'],
    emoji: '\ud83c\uddf8\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SO.svg',
  },
  ZA: {
    name: 'South Africa',
    region: 'Africa',
    timezones: {
      'Africa/Johannesburg': '+02:00',
    },
    iso: {
      'alpha-2': 'ZA',
      'alpha-3': 'ZAF',
      numeric: '710',
    },
    phone: ['+27'],
    emoji: '\ud83c\uddff\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg',
  },
  GS: {
    name: 'South Georgia and the South Sandwich Islands',
    region: 'Americas',
    timezones: {
      'Atlantic/South_Georgia': '-02:00',
    },
    iso: {
      'alpha-2': 'GS',
      'alpha-3': 'SGS',
      numeric: '239',
    },
    phone: ['+500'],
    emoji: '\ud83c\uddec\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GS.svg',
  },
  SS: {
    name: 'South Sudan',
    region: 'Africa',
    timezones: {
      'Africa/Juba': '+02:00',
    },
    iso: {
      'alpha-2': 'SS',
      'alpha-3': 'SSD',
      numeric: '728',
    },
    phone: ['+211'],
    emoji: '\ud83c\uddf8\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SS.svg',
  },
  ES: {
    name: 'Spain',
    region: 'Europe',
    timezones: {
      'Africa/Ceuta': '+02:00',
      'Atlantic/Canary': '+01:00',
      'Europe/Madrid': '+02:00',
    },
    iso: {
      'alpha-2': 'ES',
      'alpha-3': 'ESP',
      numeric: '724',
    },
    phone: ['+34'],
    emoji: '\ud83c\uddea\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg',
  },
  LK: {
    name: 'Sri Lanka',
    region: 'Asia',
    timezones: {
      'Asia/Colombo': '+05:30',
    },
    iso: {
      'alpha-2': 'LK',
      'alpha-3': 'LKA',
      numeric: '144',
    },
    phone: ['+94'],
    emoji: '\ud83c\uddf1\ud83c\uddf0',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg',
  },
  SD: {
    name: 'Sudan',
    region: 'Africa',
    timezones: {
      'Africa/Khartoum': '+02:00',
    },
    iso: {
      'alpha-2': 'SD',
      'alpha-3': 'SDN',
      numeric: '729',
    },
    phone: ['+249'],
    emoji: '\ud83c\uddf8\ud83c\udde9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg',
  },
  SR: {
    name: 'Suriname',
    region: 'Americas',
    timezones: {
      'America/Paramaribo': '-03:00',
    },
    iso: {
      'alpha-2': 'SR',
      'alpha-3': 'SUR',
      numeric: '740',
    },
    phone: ['+597'],
    emoji: '\ud83c\uddf8\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg',
  },
  SJ: {
    name: 'Svalbard and Jan Mayen',
    region: 'Europe',
    timezones: {
      'Arctic/Longyearbyen': '+02:00',
    },
    iso: {
      'alpha-2': 'SJ',
      'alpha-3': 'SJM',
      numeric: '744',
    },
    phone: ['+47'],
    emoji: '\ud83c\uddf8\ud83c\uddef',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SJ.svg',
  },
  SZ: {
    name: 'Swaziland',
    region: 'Africa',
    timezones: {
      'Africa/Mbabane': '+02:00',
    },
    iso: {
      'alpha-2': 'SZ',
      'alpha-3': 'SWZ',
      numeric: '748',
    },
    phone: ['+268'],
    emoji: '\ud83c\uddf8\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SZ.svg',
  },
  SE: {
    name: 'Sweden',
    region: 'Europe',
    timezones: {
      'Europe/Stockholm': '+02:00',
    },
    iso: {
      'alpha-2': 'SE',
      'alpha-3': 'SWE',
      numeric: '752',
    },
    phone: ['+46'],
    emoji: '\ud83c\uddf8\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg',
  },
  CH: {
    name: 'Switzerland',
    region: 'Europe',
    timezones: {
      'Europe/Zurich': '+02:00',
    },
    iso: {
      'alpha-2': 'CH',
      'alpha-3': 'CHE',
      numeric: '756',
    },
    phone: ['+41'],
    emoji: '\ud83c\udde8\ud83c\udded',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg',
  },
  SY: {
    name: 'Syrian Arab Republic',
    region: 'Asia',
    timezones: {
      'Asia/Damascus': '+03:00',
    },
    iso: {
      'alpha-2': 'SY',
      'alpha-3': 'SYR',
      numeric: '760',
    },
    phone: ['+963'],
    emoji: '\ud83c\uddf8\ud83c\uddfe',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SY.svg',
  },
  TW: {
    name: 'Taiwan, Province of China',
    region: 'Asia',
    timezones: {
      'Asia/Taipei': '+08:00',
    },
    iso: {
      'alpha-2': 'TW',
      'alpha-3': 'TWN',
      numeric: '158',
    },
    phone: ['+886'],
    emoji: '\ud83c\uddf9\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg',
  },
  TJ: {
    name: 'Tajikistan',
    region: 'Asia',
    timezones: {
      'Asia/Dushanbe': '+05:00',
    },
    iso: {
      'alpha-2': 'TJ',
      'alpha-3': 'TJK',
      numeric: '762',
    },
    phone: ['+992'],
    emoji: '\ud83c\uddf9\ud83c\uddef',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg',
  },
  TZ: {
    name: 'Tanzania, United Republic of',
    region: 'Africa',
    timezones: {
      'Africa/Dar_es_Salaam': '+03:00',
    },
    iso: {
      'alpha-2': 'TZ',
      'alpha-3': 'TZA',
      numeric: '834',
    },
    phone: ['+255'],
    emoji: '\ud83c\uddf9\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TZ.svg',
  },
  TH: {
    name: 'Thailand',
    region: 'Asia',
    timezones: {
      'Asia/Bangkok': '+07:00',
    },
    iso: {
      'alpha-2': 'TH',
      'alpha-3': 'THA',
      numeric: '764',
    },
    phone: ['+66'],
    emoji: '\ud83c\uddf9\ud83c\udded',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg',
  },
  TL: {
    name: 'Timor-Leste',
    region: 'Asia',
    timezones: {
      'Asia/Dili': '+09:00',
    },
    iso: {
      'alpha-2': 'TL',
      'alpha-3': 'TLS',
      numeric: '626',
    },
    phone: ['+670'],
    emoji: '\ud83c\uddf9\ud83c\uddf1',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TL.svg',
  },
  TG: {
    name: 'Togo',
    region: 'Africa',
    timezones: {
      'Africa/Lome': '+00:00',
    },
    iso: {
      'alpha-2': 'TG',
      'alpha-3': 'TGO',
      numeric: '768',
    },
    phone: ['+228'],
    emoji: '\ud83c\uddf9\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg',
  },
  TK: {
    name: 'Tokelau',
    region: 'Oceania',
    timezones: {
      'Pacific/Fakaofo': '+13:00',
    },
    iso: {
      'alpha-2': 'TK',
      'alpha-3': 'TKL',
      numeric: '772',
    },
    phone: ['+690'],
    emoji: '\ud83c\uddf9\ud83c\uddf0',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TK.svg',
  },
  TO: {
    name: 'Tonga',
    region: 'Oceania',
    timezones: {
      'Pacific/Tongatapu': '+13:00',
    },
    iso: {
      'alpha-2': 'TO',
      'alpha-3': 'TON',
      numeric: '776',
    },
    phone: ['+676'],
    emoji: '\ud83c\uddf9\ud83c\uddf4',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg',
  },
  TT: {
    name: 'Trinidad and Tobago',
    region: 'Americas',
    timezones: {
      'America/Port_of_Spain': '-04:00',
    },
    iso: {
      'alpha-2': 'TT',
      'alpha-3': 'TTO',
      numeric: '780',
    },
    phone: ['+1-868'],
    emoji: '\ud83c\uddf9\ud83c\uddf9',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TT.svg',
  },
  TN: {
    name: 'Tunisia',
    region: 'Africa',
    timezones: {
      'Africa/Tunis': '+01:00',
    },
    iso: {
      'alpha-2': 'TN',
      'alpha-3': 'TUN',
      numeric: '788',
    },
    phone: ['+216'],
    emoji: '\ud83c\uddf9\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg',
  },
  TR: {
    name: 'Turkey',
    region: 'Asia',
    timezones: {
      'Europe/Istanbul': '+03:00',
    },
    iso: {
      'alpha-2': 'TR',
      'alpha-3': 'TUR',
      numeric: '792',
    },
    phone: ['+90'],
    emoji: '\ud83c\uddf9\ud83c\uddf7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg',
  },
  TM: {
    name: 'Turkmenistan',
    region: 'Asia',
    timezones: {
      'Asia/Ashgabat': '+05:00',
    },
    iso: {
      'alpha-2': 'TM',
      'alpha-3': 'TKM',
      numeric: '795',
    },
    phone: ['+993'],
    emoji: '\ud83c\uddf9\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg',
  },
  TC: {
    name: 'Turks and Caicos Islands',
    region: 'Americas',
    timezones: {
      'America/Grand_Turk': '-04:00',
    },
    iso: {
      'alpha-2': 'TC',
      'alpha-3': 'TCA',
      numeric: '796',
    },
    phone: ['+1-649'],
    emoji: '\ud83c\uddf9\ud83c\udde8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TC.svg',
  },
  TV: {
    name: 'Tuvalu',
    region: 'Oceania',
    timezones: {
      'Pacific/Funafuti': '+12:00',
    },
    iso: {
      'alpha-2': 'TV',
      'alpha-3': 'TUV',
      numeric: '798',
    },
    phone: ['+688'],
    emoji: '\ud83c\uddf9\ud83c\uddfb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg',
  },
  UG: {
    name: 'Uganda',
    region: 'Africa',
    timezones: {
      'Africa/Kampala': '+03:00',
    },
    iso: {
      'alpha-2': 'UG',
      'alpha-3': 'UGA',
      numeric: '800',
    },
    phone: ['+256'],
    emoji: '\ud83c\uddfa\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg',
  },
  UA: {
    name: 'Ukraine',
    region: 'Europe',
    timezones: {
      'Europe/Kyiv': '+03:00',
      'Europe/Simferopol': '+03:00',
    },
    iso: {
      'alpha-2': 'UA',
      'alpha-3': 'UKR',
      numeric: '804',
    },
    phone: ['+380'],
    emoji: '\ud83c\uddfa\ud83c\udde6',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg',
  },
  AE: {
    name: 'United Arab Emirates',
    region: 'Asia',
    timezones: {
      'Asia/Dubai': '+04:00',
    },
    iso: {
      'alpha-2': 'AE',
      'alpha-3': 'ARE',
      numeric: '784',
    },
    phone: ['+971'],
    emoji: '\ud83c\udde6\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg',
  },
  GB: {
    name: 'United Kingdom',
    region: 'Europe',
    timezones: {
      'Europe/London': '+01:00',
    },
    iso: {
      'alpha-2': 'GB',
      'alpha-3': 'GBR',
      numeric: '826',
    },
    phone: ['+44'],
    emoji: '\ud83c\uddec\ud83c\udde7',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg',
  },
  US: {
    name: 'United States',
    region: 'Americas',
    timezones: {
      'America/Adak': '-09:00',
      'America/Anchorage': '-08:00',
      'America/Boise': '-06:00',
      'America/Chicago': '-05:00',
      'America/Denver': '-06:00',
      'America/Detroit': '-04:00',
      'America/Indiana/Indianapolis': '-04:00',
      'America/Indiana/Knox': '-05:00',
      'America/Indiana/Marengo': '-04:00',
      'America/Indiana/Petersburg': '-04:00',
      'America/Indiana/Tell_City': '-05:00',
      'America/Indiana/Vevay': '-04:00',
      'America/Indiana/Vincennes': '-04:00',
      'America/Indiana/Winamac': '-04:00',
      'America/Juneau': '-08:00',
      'America/Kentucky/Louisville': '-04:00',
      'America/Kentucky/Monticello': '-04:00',
      'America/Los_Angeles': '-07:00',
      'America/Menominee': '-05:00',
      'America/Metlakatla': '-08:00',
      'America/New_York': '-04:00',
      'America/Nome': '-08:00',
      'America/North_Dakota/Beulah': '-05:00',
      'America/North_Dakota/Center': '-05:00',
      'America/North_Dakota/New_Salem': '-05:00',
      'America/Phoenix': '-07:00',
      'America/Sitka': '-08:00',
      'America/Yakutat': '-08:00',
      'Pacific/Honolulu': '-10:00',
    },
    iso: {
      'alpha-2': 'US',
      'alpha-3': 'USA',
      numeric: '840',
    },
    phone: ['+1'],
    emoji: '\ud83c\uddfa\ud83c\uddf8',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg',
  },
  UM: {
    name: 'United States Minor Outlying Islands',
    region: 'Oceania',
    timezones: {
      'Pacific/Midway': '-11:00',
      'Pacific/Wake': '+12:00',
    },
    iso: {
      'alpha-2': 'UM',
      'alpha-3': 'UMI',
      numeric: '581',
    },
    phone: ['+1'],
    emoji: '\ud83c\uddfa\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UM.svg',
  },
  UY: {
    name: 'Uruguay',
    region: 'Americas',
    timezones: {
      'America/Montevideo': '-03:00',
    },
    iso: {
      'alpha-2': 'UY',
      'alpha-3': 'URY',
      numeric: '858',
    },
    phone: ['+598'],
    emoji: '\ud83c\uddfa\ud83c\uddfe',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg',
  },
  UZ: {
    name: 'Uzbekistan',
    region: 'Asia',
    timezones: {
      'Asia/Samarkand': '+05:00',
      'Asia/Tashkent': '+05:00',
    },
    iso: {
      'alpha-2': 'UZ',
      'alpha-3': 'UZB',
      numeric: '860',
    },
    phone: ['+998'],
    emoji: '\ud83c\uddfa\ud83c\uddff',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg',
  },
  VU: {
    name: 'Vanuatu',
    region: 'Oceania',
    timezones: {
      'Pacific/Efate': '+11:00',
    },
    iso: {
      'alpha-2': 'VU',
      'alpha-3': 'VUT',
      numeric: '548',
    },
    phone: ['+678'],
    emoji: '\ud83c\uddfb\ud83c\uddfa',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg',
  },
  VE: {
    name: 'Venezuela, Bolivarian Republic of',
    region: 'Americas',
    timezones: {
      'America/Caracas': '-04:00',
    },
    iso: {
      'alpha-2': 'VE',
      'alpha-3': 'VEN',
      numeric: '862',
    },
    phone: ['+58'],
    emoji: '\ud83c\uddfb\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VE.svg',
  },
  VN: {
    name: 'Viet Nam',
    region: 'Asia',
    timezones: {
      'Asia/Ho_Chi_Minh': '+07:00',
    },
    iso: {
      'alpha-2': 'VN',
      'alpha-3': 'VNM',
      numeric: '704',
    },
    phone: ['+84'],
    emoji: '\ud83c\uddfb\ud83c\uddf3',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg',
  },
  VG: {
    name: 'Virgin Islands, British',
    region: 'Americas',
    timezones: {
      'America/Tortola': '-04:00',
    },
    iso: {
      'alpha-2': 'VG',
      'alpha-3': 'VGB',
      numeric: '092',
    },
    phone: ['+1-284'],
    emoji: '\ud83c\uddfb\ud83c\uddec',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VG.svg',
  },
  VI: {
    name: 'Virgin Islands, U.S.',
    region: 'Americas',
    timezones: {
      'America/St_Thomas': '-04:00',
    },
    iso: {
      'alpha-2': 'VI',
      'alpha-3': 'VIR',
      numeric: '850',
    },
    phone: ['+1-340'],
    emoji: '\ud83c\uddfb\ud83c\uddee',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VI.svg',
  },
  WF: {
    name: 'Wallis and Futuna',
    region: 'Oceania',
    timezones: {
      'Pacific/Wallis': '+12:00',
    },
    iso: {
      'alpha-2': 'WF',
      'alpha-3': 'WLF',
      numeric: '876',
    },
    phone: ['+681'],
    emoji: '\ud83c\uddfc\ud83c\uddeb',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WF.svg',
  },
  YE: {
    name: 'Yemen',
    region: 'Asia',
    timezones: {
      'Asia/Aden': '+03:00',
    },
    iso: {
      'alpha-2': 'YE',
      'alpha-3': 'YEM',
      numeric: '887',
    },
    phone: ['+967'],
    emoji: '\ud83c\uddfe\ud83c\uddea',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg',
  },
  ZM: {
    name: 'Zambia',
    region: 'Africa',
    timezones: {
      'Africa/Lusaka': '+02:00',
    },
    iso: {
      'alpha-2': 'ZM',
      'alpha-3': 'ZMB',
      numeric: '894',
    },
    phone: ['+260'],
    emoji: '\ud83c\uddff\ud83c\uddf2',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg',
  },
  ZW: {
    name: 'Zimbabwe',
    region: 'Africa',
    timezones: {
      'Africa/Harare': '+02:00',
    },
    iso: {
      'alpha-2': 'ZW',
      'alpha-3': 'ZWE',
      numeric: '716',
    },
    phone: ['+263'],
    emoji: '\ud83c\uddff\ud83c\uddfc',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg',
  },
  AX: {
    name: '\u00c5land Islands',
    region: 'Europe',
    timezones: {
      'Europe/Mariehamn': '+03:00',
    },
    iso: {
      'alpha-2': 'AX',
      'alpha-3': 'ALA',
      numeric: '248',
    },
    phone: ['+358-18'],
    emoji: '\ud83c\udde6\ud83c\uddfd',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AX.svg',
  },
}
